/****************************************************************************/
// Application URLS to be updated based on environment
export const NEW_CPS_URL = process.env.REACT_APP_BASEURL;
export const CPS_VERSION = process.env.REACT_APP_VERSION;
export const TRAINING_URL = process.env.REACT_APP_TRAINING_URL;

const baseURL = `${NEW_CPS_URL}${CPS_VERSION}${"/"}`;

export default baseURL;

/* External URLS */

export const TRAINING_CONTENT_URL = `${NEW_CPS_URL}${TRAINING_URL}`;

/* API Endponts */

export const LOGIN_CONTENT_ENDPOINT = "api/login/login";

export const LOGS_ENDPOINT = "api/Log/Logs";

export const AUTHENTICATE_ENDPOINT = "/api/Login/Authenticate";

export const CHANGEPASSWORD_ENDPOINT = "/api/Login/ChangePassword";

export const INDIVIDUALPAYMENTREPORT_ENDPOINT =
  "/api/Dashboard/IndividualPaymentLimitReport";

export const ANNOUNCEMENT_VIEW_ALL_ENDPOINT = "/api/Dashboard/Announcements";

export const FIRSTTIMELOGIN_ENDPOINT = "api/Login/FirstTimeLogin";

export const FETCHUSERSECURITYQUESTION_ENDPOINT =
  "api/Login/UserSecurityQuestions";

export const VERIFYCOSTCENTERNAME_ENDPOINT = "api/Dashboard/CostCenter";

export const USERTRAINING_ENDPOINT = "api/Header/UserTraining";

export const FORGOTPASSOWRD_ENDPOINT = "/api/Login/ForgotPassword";

export const REQUESTACCOUNT_ENDPOINT = "api/Login/RequestAccount";

export const USERPROFILE_ENDPOINT = "/api/Login/UserProfile";

export const HEADER_INFORMATION_ENDPOINT = "api/Header/Header";

export const FETCH_DASHBOARD_DATA = "api/Dashboard/Dashboard";

export const LOGOUT_USER_ENDPOINT = "api/Login/Logout";

export const FETCH_TOKEN = "api/Token/Token";

export const DASHBOARD_ANNOUNCEMENT_ENDPOINT = "api/Dashboard/Announcement";

export const DASHBOARD_MESSAGE_ATTACH_ENDPOINT = "api/Dashboard/Attachment";

export const CONTACT_US = "/api/Header/ContactUs";

// Alerts
export const FRCOORDINATOR_FACULTY_REQUEST_ENDPOINT =
  "/api/Alert/FRCoordinatorFacultyRequestAlerts";
export const FACULTY_POTENTIAL_DUPLICATES_ENDPOINT =
  "/api/Alert/FacultyPotentialDuplicates";
export const NEW_FACULTY_ENDPOINT = "/api/Alert/NewFaculty";
export const MATCHED_FACULTY_ENDPONT = "/api/Alert/MatchedFaculty";
export const FACULTY_REQUEST_DETAIL_ALERT_ENDPOINT =
  "/api/Faculty/FacultyRequestDetail";
export const FACULTY_APPROVAL_ALERT_ENDPOINT =
  "/api/Alert/FacultyApprovalAlert";
export const FACULTY_APPROVAL_ALERTS_ENDPOINT =
  "/api/Alert/FacultyApprovalAlerts";
export const COST_CENTER_ALERT_ENDPOINT = "/api/Alert/CostCenterAlert";
export const COST_CENTER_ALERTS_ENDPOINT = "/api/Alert/CostCenterAlerts";
export const ACTIVITY_OWNER_ALERTS_ENDPOINT =
  "/api/Alert/ActivityOwnerAlertControls";
export const ACTIVITY_OWNER_ALERT_ENDPOINT = "/api/Alert/ActivityOwnerAlert";
export const ACTIVITY_ALERT_ENDPOINT = "/api/Alert/ActivityAlert";
export const FACULTY_MYLIST_ENDPOINT = "/api/Faculty/MyLists";
export const FACULTY_MYLIST_DELETE_ENDPOINT = "/api/Faculty/MyListDelete";
export const FACULTY_MYLIST_SAVE_ENDPOINT = "/api/Faculty/MyListSave";
export const FACULTY_MYLIST_GET_ENDPOINT = "/api/Faculty/MyList";
export const ARF_ASSIGNED_ENDPOINT = "/api/Alert/ARFAssignedAlert";
export const ARF_DISCONTINUED_ENDPONT = "/api/Alert/DiscontinueARF";
export const CMS_MANAGER_ALERT_ENDPOINT = "/api/Alert/CMSManagerAlert";
export const ADVISING_REQUEST_FORM_ALERTS_ENDPOINT =
  "/api/Alert/AdvisingRequestFormAlerts";
export const ADVISING_REQUEST_FORM_ALERT_ENDPOINT =
  "/api/Alert/AdvisingRequestFormAlert";
export const BUDGET_APPROVAL_ALERT_CONTROLS_ENDPOINT =
  "/api/Alert/BudgetApprovalAlertControls";
export const BUDGET_APPROVAL_ALERT_ENDPOINT = "/api/Alert/BudgetApprovalAlert";
export const BUDGET_APPROVAL_ALERTS_ENDPOINT =
  "/api/Alert/BudgetApprovalAlerts";
export const COORDINATOR_ALERT_CONTROLS_ENDPOINT =
  "/api/Alert/CoordinatorAlertControls";
export const COORDINATOR_ALERT_ENDPOINT = "/api/Alert/CoordinatorAlert";
export const COORDINATOR_ALERT_PRINT_ENDPOINT =
  "/api/Alert/CoordinatorAlertPrint";
export const HONORARIUM_EXCEPTION_ALERT_CONTROLS_ENDPOINT =
  "/api/Alert/HonorariumExceptionAlertControls";
export const HONORARIUM_EXCEPTION_ALERT_ENDPOINT =
  "/api/Alert/HonorariumExceptionAlert";
export const HONORARIUM_EXCEPTION_ALERTS_ENDPOINT =
  "/api/Alert/HonorariumExceptionAlerts";
export const APPROVAL_FORM_UPLOAD_ENDPOINT = "/api/Alert/ApprovalFormUpload";
export const LILLY_USER_DETAIL_ENDPOINT = "/api/Common/LillyUserDetail";
export const SERVER_MESSAGE_ENPOINT = "/api/Message/Message";
export const SERVER_MESSAGES_ENPOINT = "/api/Message/Messages";
export const FACULTY_CV_ALERT_ENDPOINT = "/api/Alert/FacultyCVAlert";
export const FACULTY_CV_ALERT_DOWNLOAD_ENDPOINT =
  "/api/Alert/FacultyCVAlertDownload";
export const FA_APPROVAL_ALERT_CONTROLS_ENDPOINT =
  "API/Alert/FAApprovalAlertControls";
export const FA_APPROVAL_ALERT_ENDPOINT = "API/Alert/FAApprovalAlert";
export const FA_APPROVAL_ALERTS_ENDPOINT = "API/Alert/FAApprovalAlerts";
export const DMC_COMPLIANCE_ALERT_ENDPOINT = "/api/Alert/DMCComplianceAlert";
export const DMC_COMPLIANCE_ALERTS_ENDPOINT = "/api/Alert/DMCComplianceAlerts";
export const NEW_ACCESS_ALERT_CONTROLS_ENDPOINT =
  "/api/Alert/NewAccessAlertControls";
export const FR_COORDINATOR_FACULTY_REQUEST_ALERT_ENDPOINT =
  "/api/Alert/FRCoordinatorFacultyRequestAlert";
export const VENUE_CATERER_APPROVAL_ALERTS_CONTROL_ENDPOINT =
  "/api/Alert/VenueCatererApprovalAlertControls";
export const VENUE_CATERER_APPROVAL_ALERT_ENDPOINT =
  "/api/Alert/VenueCatererApprovalAlert";
export const VENUE_CATERER_APPROVAL_ALERTS_ENDPOINT =
  "/api/Alert/VenueCatererApprovalAlerts";
export const MEDICAL_ALERT_CONTROL_ENDPOINT = "/api/Alert/MedicalAlertControls";
export const MEDICAL_ALERT_ENDPOINT = "/api/Alert/MedicalAlert";
export const MEDICAL_ALERTS_ENDPOINT = "/api/Alert/MedicalAlerts";
export const MEDICAL_INVOICE_ALERT_ENDPOINT = "/api/Alert/MedicalInvoiceAlert";
export const NEW_ACCESS_ALERT_ENDPOINT = "/api/Alert/NewAccessAlert";
export const PPQ_HOLDING_ALERT_ENDPOINT = "/api/Alert/PPQHoldingAreaAlert";
export const PPQ_HOLDING_ALERT_CONTROLS_ENDPOINT =
  "/api/Alert/PPQHoldingAreaAlertControls";
export const PPQ_FILE_ENDPOINT = "/api/Alert/PPQFile";
export const PPQ_TIER_RATES_COMPARISON_ENDPOINT =
  "/api/Alert/PPQTierRatesComparison";
export const SCREENING_ALERT_CONTROLS_ENDPOINT =
  "/api/Alert/ScreeningAlertControls";
export const SCREENING_ALERT_ENDPOINT = "/api/Alert/ScreeningAlert";
export const SCREENING_ALERTS_ENDPOINT = "/api/Alert/ScreeningAlerts";
export const SCREENING_RESULTS_ENDPOINT = "/api/Alert/ScreeningResults";
export const NEW_ACCESS_ALERTS_ENDPOINT = "/api/Alert/NewAccessAlerts";
export const EXPANDED_SEARCH_ENDPOINT = "/api/Common/ExpandedSearch";
export const INVITATION_TEMPLATE_APPROVAL_ALERT_ENDPOINT =
  "/api/Alert/InvitationTemplateApprovalAlert";
export const INVITATION_TEMPLATE_APPROVAL_ALERTS_ENDPOINT =
  "/api/Alert/InvitationTemplateApprovalAlerts";
export const INVITATION_TEMPLATE_PRINT_ENDPOINT =
  "/api/Alert/InvitationTemplatePrint";
export const OUS_APPROVAL_ALERT_ENDPOINT = "API/Alert/OUSApprovalAlert";
export const OUS_APPROVAL_ALERTS_ENDPOINT = "API/Alert/OUSApprovalAlerts";
export const PPQ_APPROVAL_ALERT_ENDPOINT = "/api/Alert/PPQApprovalAlert";
export const PPQ_APPROVAL_ALERTS_ENDPOINT = "/api/Alert/PPQApprovalAlerts";
export const PPQ_HOLDING_AREA_ALERT_ENDPOINT =
  "/api/Alert/PPQHoldingAreaAlerts";
export const REPORT_DETAILS_ENDPOINT = "/api/Report/Report";
export const FACULTY_PROFILE_PHOTO = "/api/Faculty/FacultyProfilePhoto";
export const DOWNLOAD_REPORT_DETAILS_ENDPOINT = "/api/Report/DownloadReport";

export const REPORT_SCHEDULER_SCHEDULE_ENDPOINT = "/api/Report/Schedule";
export const REPORT_SCHEDULER_SCHEDULES_ENDPOINT = "/api/Report/Schedules";
export const REPORT_SCHEDULER_SCHEDULED_REPORT_ENDPOINT =
  "/api/Report/UserScheduledReport";
export const REPORT_SCHEDULER_DOWNLOAD_REPORT_ENDPOINT =
  "/api/Report/DownloadScheduledReport";
export const REPORT_SCHEDULER_DELETE_SCHEDULE_ENDPOINT =
  "/api/Report/DeleteSchedule";

export const LAST_SURVEY_DETAILS = "/api/Admin/FetchUserLastSurveyDetails";
export const ORF_SUBMITTER_STATUS_ALERT_ENDPOINT =
  "/api/Alert/ORFSubmitterStatusAlert";
export const ORF_SUBMITTER_STATUS_ALERTS_ENDPOINT =
  "/api/Alert/ORFSubmitterStatusAlerts";
export const ADDITIONAL_COMPENSATION_ALERT_CONTROLS_ENDPOINT =
  "/api/Alert/AdditionalCompensationAlertControls";
export const ADDITIONAL_COMPENSATION_ALERT_ENDPOINT =
  "/api/Alert/AdditionalCompensationAlert";
export const COMPENSATION_ALLOCATION_ENDPOINT =
  "/api/Alert/CompensationAllocation";
export const COMPENSATION_ALLOCATIONS_ENDPOINT =
  "/api/Alert/CompensationAllocations";
export const ORF_APPROVAL_STATUS_ALERT_ENDPOINT =
  "/api/Alert/ORFApprovalStatusAlert";
export const ORF_APPROVAL_STATUS_ALERTS_ENDPOINT =
  "/api/Alert/ORFApprovalStatusAlerts";
export const FACULTY_VIDEO_ALERT_ENDPOINT = "/api/Alert/FacultyVideoAlert";
export const FACULTY_VIDEO_ALERTS_ENDPOINT = "/api/Alert/FacultyVideoAlerts";
export const DMC_COMPLIANCE_ALERTPREVIEW_ENDPOINT =
  "/api/Alert/DMCComplianceAlertPreview";
export const HONORARIUMLOWERED_ALERTPREVIEW_ENDPOINT =
  "/api/Alert/HonorariumAmountLoweredAlertPreview";
export const MILESTONE_PAYMENT_ALERTPREVIEW_ENDPOINT =
  "/api/Alert/MilestonePaymentAlertPreview";
export const DESC_OF_SERVICE_ALERTPREVIEW_ENDPOINT =
  "/api/Alert/DescriptionOfServicesApprovalAlertPreview";
export const HONORARIUM_EXCEPTION_ALERTPREVIEW_ENDPOINT =
  "/api/Alert/HonorariumExceptionAlertPreview";
export const ADV_ACT_INVOICE_ALERTPREVIEW_ENDPOINT =
  "/api/Alert/GetAdvisingActFallWithinInvoice";
export const ADV_ACTIVITY_SERVICE_APPROVAL_ALERTSPREVIEW =
  "/api/Alert/AdvActivityServiceApprovalAlertsPreview";
export const NONMEDICAL_PERSONNEL_APPROVAL_ALERTPREVIEW =
  "/api/Alert/NonMedicalPersonnelApprovalAlertPreview";
export const BUDGETAPPROVAL_ALERT_FOR_MEDICALPREVIEW =
  "/api/Alert/BudgetApprovalAlertForMedicalPreview";
export const BUDGETAPPROVAL_ALERT_FOR_NONMEDICALPREVIEW =
  "/api/Alert/BudgetApprovalAlertForNonMedicalPreview";
export const FACULTY_W9_VALIDATION_APPROVAL_ALERT_ENDPOINT =
  "API/Alert/FacultyW9ValidationApprovalAlert";
export const FACULTY_W9_VALIDATION_APPROVAL_ALERTS_ENDPOINT =
  "API/Alert/FacultyW9ValidationApprovalAlerts";
// Faculty
export const FACULTY_DETAIL_ENDPOINT = "/api/Faculty/FacultyDetail";
export const FACULTY_CONTROLS_ENDPOINT = "/api/Faculty/FacultyControls";
export const FACULTY_BASIC_SEARCH_CONTROLS =
  "/api/Faculty/FacultyBasicSearchControls";
export const FACULY_BASIC_SEARCH = "/api/Faculty/FacultyBasicSearch";
export const FACULTY_ADVANCED_SEARCH_CONTROLS =
  "/api/Faculty/FacultyAdvancedSearchControls";
export const FACULTY_ADVANCED_SEARCH = "/api/Faculty/FacultyAdvancedSearch";
export const FACULTY_REQUEST_DETAILS_ENDPOINT =
  "api/Faculty/FacultyRequestDetails";
export const FACULTY_STATE_LEGISLATION = "api/Common/StateLegislation";
export const VENUE_CATERER_SEARCH_CONTROLS =
  "/api/Faculty/VenueCatererSearchControls";
export const SEARCH_VENUE_CATERER_CONTROLS = "/api/Faculty/VenueCatererSearch";
export const NOMINATE_VENUE_CATERER_CONTROLS =
  "/api/Faculty/VenueCatererNominate";
export const ADD_VENUE_CATERER_CONTROLS = "/api/Faculty/VenueCatererControls";
export const FACULTY_PPQ_SEARCH = "/api/Faculty/FacultyPPQSearch";
export const FACULTY_BULK_PPQ = "/api/Faculty/BulkFacultyPPQ";
export const FACULTY_PROFILE = "/api/Faculty/FacultyProfile";
export const FACULTY_PROFILE_DOCUMENT = "/api/Faculty/FacultyProfileDocument";
export const FACULTY_PROFILE_SCREENING = "/api/Faculty/FacultyScreening";
export const FACULTY_PROFILE_SCREENING_OVERRIDE =
  "/api/Faculty/FacultyScreeningOverride";
export const FACULTY_CALENDAR_CONTROL = "/api/Faculty/FacultyCalendarControls";
export const FACULTY_CALENDAR = "/api/Faculty/FacultyCalendar";
export const FACULTY_CALENDAR_ACTIVITIES =
  "/api/Faculty/FacultyCalendarActivities";
export const FACULTY_COMMON_DEFAULTAPPROVER = "/api/Common/DefaultApprover";
export const FACULTY_COMMON_POTENTIALDUPLICATEFACULTIES =
  "/api/Common/PotentialDuplicateFaculties";
export const API_COMMON_ADDRESS = "api/Common/Address";
export const ADD_FACULTY_DETAILS = "/api/Faculty/Faculty";
export const SAVE_MULTIPLE_FACULTY = "API/faculty/MultipleFaculty";
export const MULTIPLE_FACULTY_CONTROLS = "API/faculty/MultipleFacultyControls";
export const FACULTY_DETAILS = "/api/Faculty/FacultyDetails";
export const FACULTY_BRANDS_TOPICS = "/api/Faculty/FacultyBrandTopic";
export const FACULTY_PROFILE_PPQ_DETAIL = "/api/Faculty/FacultyPPQDetail";
export const FACULTY_PROFILE_DATA_VERIFICATION = "/api/Faculty/FacultyDVDetail";
export const ADD_EDIT_VENUE_CATERERS = "/api/Faculty/VenueCaterers";
export const ADD_EDIT_VENUE_CATERER = "/api/Faculty/VenueCaterer";
export const FACULTY_PROFILE_DOCUMENT_UPLOAD = "/api/Faculty/DocumentUpload";
export const FACULTY_PROFILE_DOCUMENT_CONTROLS =
  "/api/Faculty/DocumentControls";
export const FACULTY_PROFILE_DOCUMENT_DETAILS = "/api/Faculty/DocumentDetails";
export const FACULTY_PROFILE_DOCUMENT_SEARCH = "/api/Faculty/DocumentSearch";
export const FACULTY_PROFILE_SEARCH_DEVIATION =
  "/api/Faculty/DocumentSearchDeviation";
export const FACULTY_PROFILE_DOCUMENT_DELETE = "/api/Faculty/DocumentDelete";
export const FACULTY_PROFILE_DATA_VERIFICATION_DETAILS =
  "/api/Faculty/DataVerificationDetails";
export const FACULTY_CONTRACT_CONTROL = "/api/Faculty/FacultyContractControls";
export const FACULTY_CONTRACT = "/api/Faculty/FacultyContract";
export const FACULTY_TRAINING = "/api/Faculty/FacultyTraining";
export const FACULTY_TRAINING_REQUIREMENTS =
  "/api/Faculty/FacultyTrainingRequirements";
export const FACULTY_CONTRACT_FILE = "/api/Faculty/ContractFile";
export const FACULTY_INSTITUTION_DETAILS =
  "/api/Faculty/FacultyInstitutionDetail";
export const SAVE_ACULTY_INSTITUTION_DETAILS =
  "/api/Faculty/FacultyInstitutionDetails";
export const SPEAKER_PROGRAM_PREFRENCE_HISTORY =
  "/api/Faculty/SpeakerProgramPreferenceHistory";
export const FACULTY_TIERING_CONTROLS = "/api/Faculty/TieringControls";
export const FACULTY_TIER = "/api/Faculty/Tier";
export const FACULTY_TIERS = "/api/Faculty/Tiers";
export const FACUTLY_ZEROTIER = "/api/Faculty/ZeroTier";
export const NOTE_TYPE_CONTROLS = "api/faculty/FacultyContactNoteControls";
export const FACULTY_CONTACT_NOTES = "/api/Faculty/FacultyContactNote";
export const SAVE_DELETE_CONTACT_NOTES = "/api/Faculty/FacultyContactNotes";
export const FACULTY_CONTACT_NOTES_PRINT =
  "/api/Faculty/FacultyContactNotePrint";
export const FACULTY_ACTIVITY_STATS = "/api/Faculty/FacultyActivityStats";
export const FACULTY_ACTIVITY_STATS_DETAILS =
  "/api/Faculty/FacultyActivityStatsDetails";
export const FACULTY_ACTIVITY_MAP_CONTROLS =
  "/api/Faculty/FacultyActivityMapControls";
export const FACULTY_ACTIVITY_MAP_FILTER =
  "/api/Faculty/FacultyActivityMapFilter";
export const FACULTY_ACTIVITY_MAP = "/api/Faculty/FacultyActivityMap";
export const FACULTY_TAX_FORM_UPLOAD_CONTROLS =
  "/api/Faculty/TaxFormUploadControls";
export const FACULTY_TAX_FORM = "/api/Faculty/TaxForm";
export const FACULTY_TAX_FORM_UPLOAD = "/api/Faculty/TaxFormUpload";
export const TAX_FILE_HISTORY = "/api/Faculty/TaxFileHistory";
export const SAVE_TAX_FORMS = "/api/Faculty/TaxForms";
export const FACULTY_TOPIC_INFO = "/api/Faculty/FacultyTopicInfo";
export const FACULTY_TOPIC_INFO_CONTROLS = "/api/Faculty/TopicInfoControl";
export const FACULTY_SAVE_ADD_EDIT_TOPIC_INFO = "/api/Faculty/TopicInfos";
export const FACULTY_TEXT_PROGRAM_ALERT =
  "/api/Faculty/TextMessageProgramAlerts";
export const FACULTY_TRAVEL_PREFERENCE_CONTROL =
  "/api/Faculty/TravelPreferenceControls";
export const FACULTY_TRAVEL_PREFERENCE = "/api/Faculty/TravelPreference";
export const FACULTY_SAVE_TRAVEL_PREFERENCE = "/api/Faculty/TravelPreferences";
export const FACULTY_TRAVEL_PREFERENCE_DOCUMENT =
  "/api/Faculty/TravelPreferencesDocument";
export const FACULTY_TRAVEL_PREFERENCES_DOCUMENT_OPERATION =
  "/api/Faculty/TravelPreferencesDocumentOperation";
export const FACULTY_MISCELLANEOUSCONTROLS =
  "/api/Faculty/MiscellaneousControls";
export const FACULTY_MISCELLANEOUS = "/api/Faculty/Miscellaneous";
export const FACULTY_MISCELLANEOUSES = "/api/Faculty/Miscellaneouses";
export const FACULTY_POTENTIAL_CONFLICTDATES =
  "/api/Faculty/PotentialConflictDates";
export const FACULTY_POTENTIAL_CONFLICTDATES_DELETE =
  "/api/Faculty/PotentialConflictDatesDelete";
export const FACULTY_DOCUMENT_INFORMATION_CONTROL =
  "/api/Faculty/DocumentInformationControls";
export const FACULTY_DOCUMENT_INFORMATION = "/api/Faculty/DocumentInformation";
export const FACULTY_SAVE_DOCUMENT_INFORMATION =
  "api/Faculty/DocumentInformations";
export const FACULTY_SPP_CONTROLS = "/api/Faculty/SPPControls";
export const FACULTY_FETCH_SPP = "/api/Faculty/SPP";
export const FACULTY_SAVE_SPP = "/api/Faculty/SPPs";
export const FACULTY_AFFILIATION_LICENSE = "/api/Faculty/AffiliationLicense";
export const AFFILIATION_DETAILS = "/api/Faculty/AffiliationDetails";
export const LICENSE_FILE = "/api/Faculty/LicenseFile";
export const LICENSE_CONTROLS = "/api/Faculty/LicenseControls";
export const FACULTY_SAVE_AFFILIATIONS = "/api/Faculty/Affiliations";
export const AFFILIATION_CONTROLS = "/api/Faculty/AffiliationControls";
export const AFFILIATION_RESULT = "/api/Faculty/AffiliationSearch";
export const FACULTY_LICENSES = "/api/Faculty/Licenses";
export const GET_LICENSE = "/api/Faculty/License";
export const FACULTY_CONTACT_INFO_ENDPOINT =
  "api/Faculty/FacultyRequestContactInfo";
export const FACULTY_EDIT_PROFILE_CONTROL = "/api/Faculty/EditProfileControls";
export const FACULTY_SCREENING_CONSENT = "api/Faculty/ScreeningConsent";
export const FACULTY_EXPENSE_EXCEPTION_CONTROLS =
  "/api/Faculty/ExpenseExceptionControls";
export const FACULTY_SBINDICATOR_CONTROLS = "/api/Faculty/FacultyRuleControls";
export const FACULTY_EDIT_PROFILE = "/api/Faculty/EditProfile";
export const FACULTY_EDIT_PROFILES = "/api/Faculty/EditProfiles";
export const FACULTY_EDIT_PPQ_CONTROLS = "/api/Faculty/FacultyPPQControls";
export const FACULTY_EDIT_PPQ_DETAIL = "/api/Faculty/FacultyEditPPQDetail";
export const FACULTY_EDIT_PPQ_DETAILS = "/api/Faculty/FacultyEditPPQDetails";
export const FACULTY_DATA_VERFICATIONS = "/api/Faculty/DataVerifications";
export const FACULTY_ORGANIZATION_CONTACT =
  "/api/Faculty/FacultyOrganizationContacts";
export const FACULTY_DATA_VERIFICATION = "/api/Faculty/DataVerifications";
export const FACULTY_RULE = "/api/Faculty/FacultyRule";
export const FACULTY_ADDRESS = "/api/Faculty/FacultyAddress";
export const FACULTY_ALLOCATION_CONTROLS =
  "/api/Faculty/FacultyAllocationControls";
export const FACULTY_ALLOCATION_DATA = "/api/Faculty/FacultyAllocation";
export const FACULTY_ALLOCATIONS = "/api/Faculty/FacultyAllocations";
export const FACULTY_ALLOCATE_FUND_CONTROLS =
  "/api/Faculty/AllocateFundControls";
export const FACULTY_ALLOCATE_FUND = "api/Faculty/AllocateFund";
export const FACULTY_BRAND_RULES = "api/Faculty/BrandRules";
export const FACULTY_ALLOCATION_BREAKDOWN = "api/Faculty/AllocationBreakdown";
export const FACULTY_ALIGNMENT_RULE = "api/Faculty/AlignmentRule";
export const FACULTY_ALIGNMENT_RULES = "api/Faculty/AlignmentRules";
export const FACULTY_COMPENSATION_UTILIZATION =
  "/api/Faculty/CompensationUtilization";
export const FACULTY_COMPENSATION_CONTACT_NOTE =
  "/api/Faculty/CompensationContactNote";
export const FACULTY_SAVE_COMPENSATION_CONTACT_NOTE =
  "/api/Faculty/CompensationContactNotes";
export const FACULTY_SEARCH_REPRESENTATIVE = "/api/Common/RepresentativeSearch";
export const FACULTY_ALLOCATE_FUNDS = "api/Faculty/AllocateFunds";
export const FACULTY_OPTOUT_RESEND = "/api/Faculty/IntroVideoAlert";
export const FACULTY_COMPENSATION_DOWNLOAD_TO_EXCEL =
  "api/Faculty/CompensationDownloadToExcel";
export const FACULTY_REQUEST_FOR_FUND = "/api/Faculty/RequestForFund";
export const FACULTY_BRAND_COMPENSATION_APPROVER =
  "/api/Faculty/BrandCompensationApprover";
export const FACULTY_REQUEST_FOR_FUNDS = "/api/Faculty/RequestForFunds";
export const FACULTY_ALLOCATION_BRAND_NOTES_CONTROLS = "/api/Faculty/BrandNote";
export const FACULTY_ALLOCATION_BRAND_NOTES = "/api/Faculty/BrandNotes";
export const FACULTY_ALLOCATION_DOWNLOAD_NOTES =
  "/api/Faculty/CompensationNotesDownload";
export const FACULTY_ALLOCATION_VIEW_NOTES = "/api/Faculty/ViewNotes";
export const FACULTY_VERIFY_ACTIVITY = "/api/Common/VerifyActivity";
export const LOGIN_VERIFY_MFA_OTP = "/api/Login/VerifyMfaOtp";
export const LOGIN_RESEND_OTP = "/api/Login/ResendMfaOtp";
export const COMMON_MFA_PREFERRED = "/api/Common/MfaPreferred";
export const COMMON_MFA_PREFERREDS = "/api/Common/MfaPreferreds";
export const COMMON_SEND_MFA_PHONE_OTP = "/api/Common/SendMfaPhoneOtp";
export const COMMON_VERIFY_MFA_PHONE_OTP = "/api/Common/VerifyMfaPhoneOtp";
export const ADMIN_METADATA_CONTROL = "/api/Admin/MetadataControl";
export const ADMIN_METADATA_LIST = "/api/Admin/Metadata";
export const ADMIN_METADATA_SAVE = "/api/Admin/Metadatas";
export const ADMIN_METADATA_COMPENSATION_CONTROL =
  "/api/Admin/CompensationLimitControl";
export const ADMIN_ACTIVITY_SERIES = "/api/Admin/ActivitySeries";
export const ADMIN_FACULTY_ID_CHANGE = "/api/Admin/FacultyIdChange";
export const ADMIN_METADATA_COMPENSATION_LIMIT = "/api/Admin/CompensationLimit";
export const ADMIN_METADATA_COMPENSATION_LIMIT_SAVE =
  "/api/Admin/CompensationLimits";
export const ADMIN_DOC_ON_FILE = "/api/Admin/DocOnFile";
export const ADMIN_COST_CENTER_EXCEL = "/api/Admin/CostCenterExcel";
export const ADMIN_SAVE_COST_CENTER = "/api/Admin/CostCenter";
export const ADMIN_SAVE_COST_CENTER_IMPORT = "/api/Admin/CostCenterImport";
export const ADMIN_SAMPLE_IO = "/api/Admin/IOSample";
export const ADMIN_SAVE_IO = "/api/Admin/IO";
export const ADMIN_TAX_TEXT_CONFIGURATION_LIST =
  "/api/Admin/TaxTextConfigurationList";
export const ADMIN_EDIT_TAX_TEXT_CONFIGURATION_LIST =
  "/api/Admin/TaxTextConfiguration";
export const ADMIN_SAVE_TAX_TEXT_CONFIGURATION_LIST =
  "/api/Admin/TaxTextConfigurations";
export const ADMIN_TAX_AUTHORITY_CONTROL = "/api/Admin/TaxAuthorityControl";
export const ADMIN_TAX_AUTHORITY = "/api/Admin/TaxAuthority";
export const ADMIN_SAVE_TAX_AUTHORITY = "/api/Admin/TaxAuthorities";
export const ADMIN_CLONE_TAX_AUTHORITY = "/api/Admin/TaxAuthorityClone";
export const ADMIN_MEDICALDD_FIELDS_LIST_CONTROL =
  "/api/Admin/MedicalDDFieldsListControl";
export const ADMIN_MEDICALDD_FIELDS_LIST = "/api/Admin/MedicalDDFieldsList";
export const ADMIN_MEDICALDD_FIELD_CONTROL = "/api/Admin/MedicalDDFieldControl";
export const ADMIN_MEDICALDD_FIELD_VALUE_SAVE = "/api/Admin/MedicalDDFields";
export const ADMIN_MEDICALDD_FIELD_VALUE = "/api/Admin/MedicalDDField";
export const ADMIN_1099_REPORTING_APPROVAL = "/api/Admin/1099ReportingApproval";
export const ADMIN_1099_REPORT_FILE = "/api/Admin/1099ReportFile";
export const ADMIN_1099_REPORTING_APPROVAL_UPLOAD =
  "/api/Admin/1099ReportingApprovalUpload";
export const ADMIN_DOWNLOAD_1099_FILE = "/api/Admin/1099File";
export const ADMIN_DOWNLOAD_1099_IRS_FILE = "/api/Admin/1099IRSFile";
export const ADMIN_PREVIEW_EXPORT_CONTROL =
  "/api/Admin/PreviewExport1099Control";
export const ADMIN_1099_GENERATE_DETAIL_REPORT =
  "/api/Admin/1099GenerateDetailReport";
export const ADMIN_1099_PREVIEW_EXPORT_SEARCH =
  "/api/Admin/PreviewExport1099Search";
export const ADMIN_1099_REPORTING_APPROVALS =
  "/api/Admin/1099ReportingApprovals";
export const ADMIN_AFFILIATION_CONTROL = "/api/Admin/AffiliationControl";
export const ADMIN_SEARCH_AFFILIATION = "/api/Admin/AffiliationSearch";
export const ADMIN_FETCH_AFFILIATION = "/api/Admin/Affiliation";
export const ADMIN_SAVE_AFFILIATION = "/api/Admin/Affiliations";
export const ADMIN_SCREENING_CONTROL = "/api/Admin/ScreeningControl";
export const ADMIN_SEARCH_SCREENING = "/api/Admin/Screening";
export const ADMIN_SCREENING_RESULTS = "/api/Admin/ScreeningResults";
export const ADMIN_SUPPLIER_BRAND_RULE_SEARCH_CONTROL =
  "/api/Admin/SupplierBrandRuleSearchControl";
export const ADMIN_SUPPLIER_BRAND_RULE_SEARCH =
  "/api/Admin/SupplierBrandRuleSearch";
export const ADMIN_SCREENING_ENTITY_SEARCH = "/api/Admin/ScreeningEntitySearch";
export const ADMIN_SAVE_SCREENING_ENTITY = "/api/Admin/ScreeningEntity";
export const ADMIN_GET_AFR_CONFIG = "/api/Admin/ORFConfig";
export const ADMIN_SAVE_AFR_CONFIG = "/api/Admin/ORFConfigs";
export const ADMIN_GET_ORF_CONFIG_COMMENT = "/api/Admin/ORFConfigComment";
export const ADMIN_SAVE_ORF_CONFIG_COMMENT = "/api/Admin/ORFConfigComments";
export const ADMIN_SUPPLIER_BRAND_RULE = "/api/Admin/SupplierBrandRuleControl";
export const ADMIN_SUPPLIER_BRAND_RULE_SAVE = "/api/Admin/SupplierBrandRules";
export const ADMIN_SUPPLIER_BRAND_RULE_FETCH = "/api/Admin/SupplierBrandRule";
export const ADMIN_SUPPLIER_MAPPING_LIST = "/api/Admin/SupplierMappingList";
export const ADMIN_SUPPLIER_MAPPING_CONTROLS =
  "/api/Admin/SupplierMappingControl";
export const ADMIN_SUPPLIER_MAPPING_FETCH = "/api/Admin/SupplierMapping";
export const ADMIN_SUPPLIER_MAPPING_SAVE = "/api/Admin/SupplierMappings";
export const ADMIN_VMS_FACULTY_CONTROL = "/api/Admin/VMSFacultyControl";
export const ADMIN_VMS_FACULTY_LIST = "/api/Admin/VMSFacultyList";
export const ADMIN_VMS_FACULTY_DETAILS_FETCH = "/api/Admin/VMSFaculty";
export const ADMIN_VMS_FACULTY_SEARCH_CONTOL =
  "/api/Admin/VMSFacultySearchControl";
export const ADMIN_VMS_FACULTY_SEARCH_FACULTY = "/api/Admin/VMSFacultySearch";
export const ADMIN_VMS_FACULTY_DETAILS_SAVE = "/api/Admin/VMSFaculties";
export const ADMIN_FIELD_ALIGNMENT_MAPPING_CONTROL =
  "/api/Admin/FieldAlignmentMappingControl";
export const ADMIN_SAVE_FIELD_ALIGNMENT_MAPPING =
  "/api/Admin/FieldAlignmentMapping";
export const ADMIN_GET_REQUEST_FORM_CONFIGURATION_CONTROL =
  "/api/Admin/RequestFormConfiguration";
export const ADMIN_SAVE_REQUEST_FORM_CONFIGURATION =
  "/api/Admin/RequestFormConfigurations";
export const ADMIN_GET_REQUEST_FORM_CONFIGURATION_COMMENT =
  "/api/Admin/RequestFormConfigurationComment";
export const ADMIN_SAVE_REQUEST_FORM_CONFIGURATION_COMMENT =
  "/api/Admin/RequestFormConfigurationComments";
export const ADMIN_GET_REQUEST_FORM = "/api/Admin/RequestForm";
export const ADMIN_SAVE_REQUEST_FORM = "/api/Admin/RequestForms";

export const RESOURCE_POST_LIST = "/api/Resource/ResourceList";
export const RESOURCE_POST_CONTENT = "/api/Resource/ResourceContent";
export const RESOURCE_POST_FILE = "/api/Resource/ResourceFile";
// start admin -> Ad Board/SAA -> Advising Central Member
export const ADVISING_CENTRAL_MEMBER_CONTROL =
  "/api/Admin/AdvisingCentralMember";
export const ADVISING_CENTRAL_MEMBERS = "/api/Admin/AdvisingCentralMembers";
// end

// start admin -> Ad Board/SAA -> Affiliates
export const AFFILIATE_LIST = "/api/Admin/AffiliateList";
export const SAVE_AFFILIATE_DETAILS = "/api/Admin/Affiliates";
export const FETCH_AFFILIATE_DETAILS = "/api/Admin/Affiliate";
// end

// start admin -> Ad Board/SAA -> Credentials for Payment Limits
export const FETCH_PAYMENT_LIMIT_CREDENTIAL =
  "/api/Admin/PaymentLimitCredential";
export const SAVE_PAYMENT_LIMIT_CREDENTIAL =
  "/api/Admin/PaymentLimitCredentials";
// end

// start admin -> Ad Board/SAA -> Anticipated Work Products
export const FETCH_ANTICIPATED_WORK_PRODUCT_LIST =
  "/api/Admin/AnticipatedWorkProductList";
export const FETCH_ANTICIPATED_WORK_PRODUCT_DETAILS =
  "/api/Admin/AnticipatedWorkProduct";
export const SAVE_ANTICIPATED_WORK_PRODUCT_DETAILS =
  "/api/Admin/AnticipatedWorkProducts";
// end

// start admin -> Ad Board/SAA -> Commercial Decision Status
export const FETCH_COMMERCIAL_DECISION_STATUS_LIST =
  "/api/Admin/CommercialDecisionStatusList";
export const FETCH_COMMERCIAL_DECISION_STATUS_DETAILS =
  "/api/Admin/CommercialDecisionStatus";
export const SAVE_COMMERCIAL_DECISION_STATUS_DETAILS =
  "/api/Admin/CommercialDecisionStatuses";
// end

// start admin -> Ad Board/SAA -> Communication Type
export const FETCH_COMMUNICATION_TYPE_LIST = "/api/Admin/CommunicationTypeList";
export const FETCH_COMMUNICATION_TYPE_DETAILS = "/api/Admin/CommunicationType";
export const SAVE_COMMUNICATION_TYPE_DETAILS = "/api/Admin/CommunicationTypes";
// end

// start admin -> Ad Board/SAA -> Non-Medical Personnel Areas
export const FETCH_NON_MEDICAL_PERSONNEL_AREA_LIST =
  "/api/Admin/NonMedicalPersonnelAreaList";
export const FETCH_NON_MEDICAL_PERSONNEL_AREA_DETAILS =
  "/api/Admin/NonMedicalPersonnelArea";
export const SAVE_NON_MEDICAL_PERSONNEL_AREA_DETAILS =
  "/api/Admin/NonMedicalPersonnelAreas";
// end

// start admin -> Ad Board/SAA -> Business Areas
export const FETCH_BUSINESS_UNITS_LIST = "/api/Admin/BusinessAreaList";
export const FETCH_BUSINESS_UNITS_DETAILS = "/api/Admin/BusinessArea";
export const SAVE_BUSINESS_UNITS_DETAILS = "/api/Admin/BusinessAreas";
export const BUSINESS_UNITS_CONTROL = "/api/Admin/BusinessAreaControl";
// end

// start admin -> Ad Board/SAA -> Therapeutic Areas
export const FETCH_THERAPEUTIC_AREA_LIST = "/api/Admin/TherapeuticAreaList";
export const THERAPEUTIC_AREA_CONTROL = "/api/Admin/TherapeuticAreaControl";
export const FETCH_THERAPEUTIC_AREA_DETAILS = "/api/Admin/TherapeuticArea";
export const SAVE_THERAPEUTIC_AREA_DETAILS = "/api/Admin/TherapeuticAreas";
// end

// start admin -> Ad Board/SAA -> Individual Payment Limits
export const INDIVIDUAL_PAYMENT_LIMIT_SEARCH_CONTROL =
  "/api/Admin/IndividualPaymentLimitSearchControl";
export const INDIVIDUAL_PAYMENT_LIMIT_SEARCH =
  "/api/Admin/IndividualPaymentLimitSearch";
export const INDIVIDUAL_PAYMENT_LIMIT_CONTROL =
  "/api/Admin/IndividualPaymentLimitControl";
export const FETCH_INDIVIDUAL_PAYMENT_LIMIT_DETAILS =
  "/api/Admin/IndividualPaymentLimit";
export const SAVE_INDIVIDUAL_PAYMENT_LIMIT_DETAILS =
  "/api/Admin/IndividualPaymentLimits";
// end

// start admin -> utilities -> District Territory Manager
export const DISTRICT_TERRITORY_MANAGER_CONTROL =
  "/api/Admin/DistrictTerritoryManagerControl";
export const DISTRICT_TERRITORY_MANAGER_FACULTY_SEARCH =
  "/api/Admin/DistrictTerritoryManagerFacultySearch";
export const DISTRICT_TERRITORY_MANAGER_DOWNLOAD =
  "/api/Admin/DistrictTerritoryManagerDownload";
export const DISTRICT_TERRITORY_MANAGER_UPLOAD =
  "/api/Admin/DistrictTerritoryManagerUpload";
// end

//Admin - utilities - AI
export const ADMIN_AICOMPLIANCEQUEUE_CONTROL =
  "/api/Admin/AIComplianceMonitoringQueueControl";
export const ADMIN_SEARCH_AICOMPLIANEQUEUE =
  "/api/Admin/AIComplianceQueueSearch";
export const AI_QUEUE_SUBMITTER_ENDPOINT = "/api/Admin/AIQueue";
export const ADMIN_QUEUE_HISTORY = "/api/Admin/AIQueueHistory";

export const ADMIN_AICOMPLIANCE_RULE_CONFIGURATION_CONTROL =
  "/api/Admin/AIComplianceRuleConfigurationControl";
export const ADMIN_SEARCH_AICOMPLIANCE_RULE =
  "/api/Admin/AIComplianceRulesSearch";

// start admin -> utilities -> Update sApprover
export const UPDATE_APPROVERS_CONTROL = "/api/Admin/ApproverConfiguration";
export const APPROVER_CONFIGURATIONS_SEARCH =
  "/api/Admin/ApproverConfigurationSearch";
export const SAVE_APPROVER_CONFIGURATIONS = "/api/Admin/ApproverConfigurations";
export const ADMIN_SUPPLIER_LIST = "/api/Admin/SupplierList";
export const ADMIN_SUPPLIER_CONTROL = "/api/Admin/SupplierControl";
export const ADMIN_SUPPLIER_DETAILS = "/api/Admin/Supplier";
export const ADMIN_SUPPLIER_DETAILS_SAVE = "/api/Admin/Suppliers";
export const ADMIN_SUPPLIER_USER_LIST = "/api/Admin/SupplierUserList";
export const ADMIN_SUPPLIER_COMMENTS = "/api/Admin/SupplierComment";
export const ADMIN_SUPPLIER_COMMENTS_SAVE = "/api/Admin/SupplierComments";

// start admin -> Activity Configuration ->
export const ADMIN_PAYMENT_CONFIGURATION_SEARCH_CONTROL =
  "/api/Admin/PaymentConfigurationSearchControl";
export const ADMIN_PAYMENT_CONFIGURATION_SEARCH =
  "/api/Admin/PaymentConfigurationSearch";
export const ADMIN_PAYMENT_CONFIGURATION_CONTROL =
  "/api/Admin/PaymentConfigurationControl";
export const ADMIN_PAYMENT_CONFIGURATION_BATCH =
  "/api/Admin/BatchConfiguration";
export const SAVE_ADMIN_PAYMENT_CONFIGURATIONS =
  "/api/Admin/BatchConfigurations";
export const ADMIN_PAYMENT_CONFIG_MONITOR_CONFIGURATION =
  "/api/Admin/MonitorConfiguration";
export const SAVE_ADMIN_PAYMENT_CONFIG_MONITOR_CONFIGURATION =
  "/api/Admin/MonitorConfigurations";
// Start admin -> Brands -> Brand Aprrovers
export const ADMIN_BRAND_APPROVER_CONTROL = "/api/Admin/BrandApproverControl";
export const ADMIN_BRAND_APPROVERS = "/api/Admin/BrandApprover";
export const ADMIN_DOWNLOAD_BRAND_APPROVERS =
  "/api/Admin/BrandApproverDownload";
export const ADMIN_BRAND_APPROVER_DELETE = "/api/Admin/BrandApproverDelete";
export const ADMIN_BRAND_ASSIGN_APPROVER = "/api/Admin/AssignApprover";
export const ADMIN_BRAND_ASSIGN_APPROVER_SAVE = "/api/Admin/AssignApprovers";
export const ADMIN_BRAND_COMPENSATION_CONTROL =
  "/api/Admin/CompensationManagerApproverControl";
export const ADMIN_BRAND_COMPENSATION_APPROVERS =
  "/api/Admin/CompensationManagerApprover";
export const ADMIN_BRAND_COMPENSATION_DELETE =
  "/api/Admin/CompensationManagerApproverDelete";
//End

// Start admin -> Brands -> Aprrovers
export const ADMIN_APPROVER_ASSIGNMENT_LIST =
  "/api/Admin/ApproverAssignmentList";
export const ADMIN_APPROVER_ASSIGNMENT_CONTROL =
  "/api/Admin/ApproverAssignmentControl";
export const ADMIN_APPROVER_ASSIGNMENT_SPONSOR =
  "/api/Admin/ApproverAssignmentSponsor";
export const ADMIN_APPROVER_ASSIGNMENT = "/api/Admin/ApproverAssignment";
export const ADMIN_APPROVER_ASSIGNMENTS_SAVE = "/api/Admin/ApproverAssignments";
//End

//Start -> Brands -> OUS Approvers
export const ADMIN_OUS_APPROVER_CONTROL = "/api/Admin/OUSApproverControl";
export const ADMIN_OUS_APPROVERS = "/api/Admin/OUSApprover";
export const ADMIN_DOWNLOAD_OUS_APPROVERS = "/api/Admin/OUSApproverDownload";
export const ADMIN_OUS_APPROVERS_DELETE = "/api/Admin/OUSApproverDelete";
//end

export const ADMIN_GET_SPP_BRAND_CONFIG = "/api/Admin/SPPBrandConfiguration";
export const ADMIN_SAVE_SPP_BRAND_CONFIG = "/api/Admin/SPPBrandConfigurations";
export const ADMIN_SEARCH_SPP_NOTIFICATION = "/api/Admin/SPPNotificationSearch";
export const ADMIN_SAVE_SPP_NOTIFICATION = "/api/Admin/SPPNotification";
export const ADMIN_SEARCH_SPP_ANNUAL_NOTIFICATION =
  "/api/Admin/SPPAnnualNotification";
export const ADMIN_SAVE_SPP_ANNUAL_NOTIFICATION =
  "/api/Admin/SPPAnnualNotifications";
export const ADMIN_GET_SPP_BRAND_CONFIGURATION_COMMENT =
  "/api/Admin/SPPBrandConfigurationComment";
export const ADMIN_ADDEDIT_SPP_BRAND_CONFIGURATION_COMMENT =
  "/api/Admin/SPPBrandConfigurationComments";

// Brands and Sub brands
export const ADMIN_GET_BRAND_CONFIGURATION_LIST =
  "/api/Admin/BrandConfigurationList";
export const ADMIN_GET_COST_CENTER_RULE_LIST = "/api/Admin/CostCenterRule";
export const ADMIN_GET_BRAND_CONFIGURATION_CONTROL =
  "/api/Admin/BrandConfigurationControl";
export const ADMIN_GET_BRAND_CONFIGURATION = "/api/Admin/BrandConfiguration";
export const ADMIN_GET_BRAND_HISTORY = "/api/Admin/BrandHistory";
export const ADMIN_GET_BRAND_HELP_CONTENT = "/api/Admin/BrandHelpContent";
export const ADMIN_SAVE_BRAND_LOGO = "/api/Admin/BrandLogo";
export const ADMIN_SAVE_BRAND_CONFIGURATION = "/api/Admin/BrandConfigurations";

//start -> Admin -> Contract -> AssignerAlignment
export const ADMIN_ASSIGNER_ALIGNMENTS = "/api/Admin/AssignerAlignment";
export const ADMIN_SEARCH_ASSIGNER_ALIGNMENTS =
  "/api/Admin/AssignerAlignmentSearch";
export const ADMIN_DOWNLOAD_ASSIGNER_ALIGNMENTS =
  "/api/Admin/AssignerAlignmentDownload";
export const ADMIN_ASSIGNER_ALIGNMENTS_DIVISION_CONTROL =
  "/api/Admin/AssignerAlignmentDivisionControl";
export const ADMIN_ASSIGNER_ALIGNMENT_DIVISIONS_SAVE =
  "/api/Admin/AssignerAlignmentDivisions";
export const ADMIN_ASSIGNER_ALIGNMENT_DIVISION_FETCH =
  "/api/Admin/AssignerAlignmentDivision";
export const ADMIN_ASSIGNER_ALIGNMENT_DELETE =
  "/api/Admin/AssignerAlignmentDelete";
export const ADMIN_ASSIGNER_ALIGNMENT_ADD = "/api/Admin/AssignerAlignmentAdd";

export const ADMIN_ALERT_PREFERENCE_SCREEN_CONTROL_GET =
  "/api/Admin/AlertPreferencesScreenControl";
export const ADMIN_ALERT_PREFERENCE_SCREEN_POST =
  "/api/Admin/AlertPreferencesScreen";
export const ADMIN_ALERT_PREFERENCES_SCREENS_POST =
  "/api/Admin/AlertPreferencesScreens";
export const ADMIN_CONTACT_NOTE_CONFIG_LIST_POST =
  "/api/Admin/ContactNoteConfigList";
export const ADMIN_CONTACT_NOTE_CONFIG_CONTROL_GET =
  "/api/Admin/ContactNoteConfigControl";
export const ADMIN_CONTACT_NOTE_CONFIG_POST = "/api/Admin/ContactNoteConfig";
export const ADMIN_CONTACT_NOTE_CONFIGS_POST = "/api/Admin/ContactNoteConfigs";

export const ADMIN_CONTENT_MANAGEMENT_LIST_POST =
  "/api/Admin/ContentManagementList";
export const ADMIN_CONTENT_LIST_POST = "/api/Admin/ContentList";
export const ADMIN_CONTENT_MANAGEMENT_FOLDER_POST =
  "/api/Admin/ContentManagementFolder";
export const ADMIN_CONTENT_MANAGEMENT_FILE_DELETE_POST =
  "/api/Admin/ContentManagementFileDelete";
export const ADMIN_CONTENT_MANAGEMENT_RANK_POST =
  "/api/Admin/ContentManagementRank";
export const ADMIN_CONTENT_MANAGEMENT_FILE_POST =
  "/api/Admin/ContentManagementFile";
export const ADMIN_CONTENT_MANAGEMENT_FILES_POST =
  "/api/Admin/ContentManagementFiles";
export const ADMIN_CONTENT_MANAGEMENT_FILE_VERSION_DOWNLOAD_POST =
  "/api/Admin/ContentManagementFileVersionDownload";
export const ADMIN_CONTENT_MANAGEMENT_FILE_CONTROL_GET =
  "/api/Admin/ContentManagementFileControl";
export const ADMIN_CONTENT_MANAGEMENT_FILE_DOWNLOAD_POST =
  "/api/Admin/ContentManagementFileDownload";
export const ADMIN_CONTENT_MANAGEMENT_PERMISSION_CPP_ACCESSIBLE_POST =
  "/api/Admin/ContentManagementPermissionCPPAccessible";
export const ADMIN_CONTENT_MANAGEMENT_PERMISSION_CONTROL_POST =
  "/api/Admin/ContentManagementPermissionControl";
export const ADMIN_CONTENT_MANAGEMENT_PERMISSION_USERS_POST =
  "/api/Admin/ContentManagementPermissionUsers";
export const ADMIN_CONTENT_MANAGEMENT_PERMISSION_FR_USERS_POST =
  "/api/Admin/ContentManagementPermissionFRUsers";
export const ADMIN_CONTENT_MANAGEMENT_PERMISSION_FR_USER_DELETE_POST =
  "/api/Admin/ContentManagementPermissionFRUserDelete";
export const ADMIN_CONTENT_MANAGEMENT_PERMISSION_POST =
  "/api/Admin/ContentManagementPermission";
export const ADMIN_CONTENT_MANAGEMENT_PERMISSIONS_POST =
  "/api/Admin/ContentManagementPermissions";
export const ADMIN_CONTENT_MANAGEMENT_PERMISSIONS_SEARCH_POST =
  "/api/Admin/ContentManagementPermissionSearch";
export const ADMIN_CONTENT_MANAGEMENT_PERMISSIONS_USER_GROUP_POST =
  "/api/Admin/ContentManagementPermissionUserGroup";
export const ADMIN_USER_GROUP_SEARCH_CONTROL_GET =
  "/api/Admin/UserGroupSearchControl";
export const ADMIN_USER_GROUP_POST = "/api/Admin/UserGroup";
export const ADMIN_USER_GROUPS_POST = "/api/Admin/UserGroups";
export const ADMIN_USER_GROUP_CONTROL_GET = "/api/Admin/UserGroupControl";
export const ADMIN_USER_GROUP_SEARCH_POST = "/api/Admin/UserGroupSearch";
// Admin: Business Justification
export const ADMIN_BUSINESS_JUSTIFICATION_SEARCH_CONTROL =
  "/api/Admin/BusinessJustificationSearchControl";
export const ADMIN_BUSINESS_JUSTIFICATION_SUGGEST =
  "/api/Admin/BusinessJustificationSuggest";
export const ADMIN_BUSINESS_JUSTIFICATION_SEARCH =
  "/api/Admin/BusinessJustificationSearch";
export const ADMIN_BUSINESS_JUSTIFICATION_CONTROL =
  "/api/Admin/BusinessJustificationControl";
export const ADMIN_BUSINESS_JUSTIFICATION = "/api/Admin/BusinessJustification";
export const ADMIN_BUSINESS_JUSTIFICATIONS =
  "/api/Admin/BusinessJustifications";
//end

// Start admin -> Contracts -> Finalize Strategic Funds
export const FINALIZE_STRATEGIC_FUND_CONTROL =
  "/api/Admin/FinalizeStrategicFundControl";
export const FINALIZE_STRATEGIC_FUNDS = "/api/Admin/FinalizeStrategicFunds";
export const FINALIZE_STRATEGIC_FUNDS_DOWNLOAD =
  "/api/Admin/FinalizeStrategicFundDownload";
//end

// Faculty Selection Rules
export const ADMIN_GET_FACULTY_SELECTION_RULE_LIST =
  "/api/Admin/FacultySelectionRuleList";
export const ADMIN_FACULTY_SELECTION_RULE_CONTROL =
  "/api/Admin/FacultySelectionRuleControl";
export const ADMIN_EDIT_FACULTY_SELECTION_RULE =
  "/api/Admin/FacultySelectionRule";
export const ADMIN_SAVE_FACULTY_SELECTION_RULE =
  "/api/Admin/FacultySelectionRules";

//start Admin-> Contracts -> Alignment Limits
export const ADMIN_ALIGNMENT_LIMIT_LIST = "/api/Admin/AlignmentLimitList";
export const ADMIN_ALIGNMENT_LIMIT_CONTROL = "/api/Admin/AlignmentLimitControl";
export const ADMIN_ALIGNMENT_LIMITS_SAVE = "/api/Admin/AlignmentLimits";
export const ADMIN_ALIGNMENT_LIMIT = "/api/Admin/AlignmentLimit";
//end

//start Admin-> Contracts -> Contract Templates
export const CONTRACT_TEMPLATE_CONTROL = "/api/Admin/ContractTemplateControl";
export const CONTRACT_TEMPLATE_REFRESH_OWNERSHIP =
  "/api/Admin/OwnershipRefresh";
export const CONTRACT_TEMPLATE_SEARCH = "/api/Admin/ContractTemplateSearch";
export const CONTRACT_TEMPLATE_FILE = "/api/Admin/ContractTemplateFile";
export const CONTRACT_TEMPLATE_INFORMATION_CONTROL =
  "/api/Admin/ContractTemplateInformationControl";
export const CONTRACT_TEMPLATE_INFORMATION =
  "/api/Admin/ContractTemplateInformation";
export const SAVE_CONTRACT_TEMPLATE_INFORMATIONS =
  "/api/Admin/ContractTemplateInformations";
export const CONTRACT_TEMPLATE_MERGE_FIELD =
  "/api/Admin/ContractTemplateMergeField";
export const SAVE_CONTRACT_TEMPLATE_MERGE_FIELD =
  "/api/Admin/ContractTemplateMergeFields";
export const CONTRACT_TEMPLATE_DELETE_COMMENTS =
  "/api/Admin/ContractTemplateComments";
export const CONTRACT_TEMPLATE_REFRESH_COMMENTS =
  "/api/Admin/ContractTemplateComment";
//end

//Admin -> Brands -> Topics Training Requirements
export const ADMIN_TOPIC_REQ_CONTROL =
  "/api/Admin/TopicsTrainingRequirementControl";
export const ADMIN_TOPIC_REQ_LIST = "/api/Admin/TopicsTrainingRequirementList";
export const ADMIN_TOPIC_REQ_FETCH = "/api/Admin/TopicsTrainingRequirement";
export const ADMIN_TOPIC_REQ_SAVE = "/api/Admin/TopicsTrainingRequirements";
export const ADMIN_TOPIC_REQ_History =
  "/api/Admin/TopicsTrainingRequirementHistory";
export const ADMIN_TOPIC_TRAINING_FETCH_FILE = "/api/Admin/ScormDownload";
export const ADMIN_TOPIC_TRAINING_SCORM_PREVIEW = "/api/Admin/ScormPreview";

//Admin -> Contracts -> Contract Management
export const ADMIN_CONTRACT_MANAGEMENT_CONTROL =
  "/api/Admin/ContractManagementControl";
export const ADMIN_SEARCH_CONTRACT_MANAGEMENT_CONTROL =
  "/api/Admin/ContractManagementSearch";
export const ADMIN_FETCH_CONTRACT_HISTORY_CONTROL =
  "/api/Admin/ContractHistoryControl";
export const ADMIN_SEARCH_CONTRACT_HISTORY = "/api/Admin/ContractHistorySearch";
export const ADMIN_SAVE_CONTRACT_HISTORY = "/api/Admin/ContractHistory";
export const ADMIN_GET_CONTRACT_FILE = "/api/Admin/Contract";
export const ADMIN_GET_CONTRACT_EMAIL = "/api/Admin/ContractEmail";
export const ADMIN_SEND_CONTRACT_EMAIL = "/api/Admin/ContractEmailSend";
export const ADMIN_SAVE_CONTRACT_MANAGEMENT = "/api/Admin/ContractManagement";
export const END_DATE_BULK_UPLOAD =
  "/api/Admin/SaveEndDateBulkUpload";
export const ADMIN_UPDATE_CONTRACT_MANAGEMENT_COPY = "/api/Admin/ContractManagementContractCopy";

//Admin -> Brands -> Topics Training Requirements Administration
export const ADMIN_TOPIC_TRAINING_ADMIN_CONTROL =
  "/api/Admin/TopicsTrainingRequirementAdminControl";
export const ADMIN_TOPIC_TRAINING_ADMIN_FACULTY_CONTROL =
  "/api/Admin/TopicAdminFacultyControl";
export const ADMIN_TOPIC_TRAINING_ADMIN_FACULTY_SEARCH =
  "/api/Admin/TopicAdminFacultySearch";
export const ADMIN_TOPIC_TRAINING_ADMIN_FACULTY_SAVE =
  "/api/Admin/TopicAdminFaculty";
export const ADMIN_TOPIC_TRAINING_ADMIN_ACTIVITY_CONTROL =
  "/api/Admin/TopicAdminActivityControl";
export const ADMIN_TOPIC_TRAINING_ADMIN_ACTIVITY_SEARCH =
  "/api/Admin/TopicAdminActivitySearch";
export const ADMIN_TOPIC_TRAINING_ADMIN_ACTIVITY_SAVE =
  "/api/Admin/TopicAdminActivity";
export const ADMIN_TOPIC_TRAINING_FIELD_ACTIVITY_CONTROL =
  "/api/Admin/TopicAdminFieldActivityControl";
export const ADMIN_TOPIC_TRAINING_FIELD_ACTIVITY_SEARCH =
  "/api/Admin/TopicAdminFieldActivitySearch";
export const ADMIN_TOPIC_TRAINING_FIELD_ACTIVITY_SAVE =
  "/api/Admin/TopicAdminFieldActivity";
export const ADMIN_COMPLIANCE_ACKNOWLEDGE_FORM =
  "/api/Common/ComplianceAcknowledgementForm";
//End Admin -> Brands -> Topics Training Requirements Administration

//Admin -> Admin Tools -> Credentials and Specialties
export const ADMIN_CREDENTIAL_CONTROL = "/api/Admin/CredentialSpecialtyControl";
export const ADMIN_CREDENTIAL_LIST = "/api/Admin/CredentialSpecialtyList";
export const ADMIN_CREDENTIAL_SAVE = "/api/Admin/Credentials";
export const ADMIN_CREDENTIAL_FETCH = "/api/Admin/Credential";
export const ADMIN_SPECIALTY_SAVE = "/api/Admin/Specialties";
export const ADMIN_SPECIALTY_FETCH = "/api/Admin/Specialty";
//End Admin -> Admin Tools -> Credentials and Specialties

export const ADMIN_AICOMPLIANCEMONITORINGQUEUE_CONTROL =
  "/api/Admin/AIComplianceMonitoringQueueControl";
export const ADMIN_GET_AICOMPLIANCEREVIEW_CONTROL =
  "/api/Admin/AIComplianceFindingsControls";
export const ADMIN_SEARCH_AICOMPLIANCEREVIEW =
  "/api/Admin/AIComplianceFindingsSearch";
export const ADMIN_GET_AICOMPLIANCE_ActivityIdentityDetails =
  "/api/Admin/AIComplianceIdentityDetails";
export const ADMIN_SEARCH_AICOMPLIANCEGetFlagDetails =
  "/api/Admin/AIComplianceFlagDetails";
export const ADMIN_GET_AICOMPLIANCEACTIVITYCOMMENTHISTORY =
  "/api/Admin/AIComplianceFlagCommentHistory";
export const ADMIN_SAVE_AIComplianceQueueActivitySync =
  "/api/Admin/AIComplianceQueueActivitySync";
export const ADMIN_UPDATE_AIComplianceActivityFlagComment =
  "/api/Admin/AIComplianceUpdateFlagComment";
export const ADMIN_Save_AICOMPLIANCEFlagDetails =
  "/api/Admin/AIComplianceSaveFlagDetails";
export const ADMIN_GET_AICOMPLIANCERULECONFIGURATION_CONTROL =
  "/api/Admin/AIComplianceRuleControl";
export const ADMIN_GET_AICOMPLIANCERULEIDDETAILS =
  "/api/Admin/AIComplianceRule";
export const ADMIN_SAVE_AICOMPLIANCERULECONFIGURATION =
  "/api/Admin/AIComplianceRules";

//Admin -> Admin Tools -> Excluded Approvers
export const ADMIN_EXCLUDED_APPROVER_SEARCH =
  "/api/Admin/ExcludedApproverSearch";
export const ADMIN_EXCLUDED_APPROVER_FETCH = "/api/Admin/ExcludedApprover";
export const ADMIN_EXCLUDED_APPROVER_SAVE = "/api/Admin/ExcludedApprovers";
//End Admin -> Admin Tools -> Excluded Approvers

//Admin -> Admin Tools -> FR Content Associations
export const ADMIN_FR_CONTENT_ASSO_CONTROL =
  "/api/Admin/FRContentAssociationControl";
export const ADMIN_FR_CONTENT_ASSO_SEARCH =
  "/api/Admin/FRContentAssociationSearch";
export const ADMIN_FR_CONTENT_ASSO_DETAILS = "/api/Admin/FRContentAssociation";
export const ADMIN_FR_CONTENT_ASSO_USERGROUP_CONTROL =
  "/api/Admin/FRContentAssociationUserGroupControl";
export const ADMIN_FR_CONTENT_ASSO_USERGROUP_SEARCH =
  "/api/Admin/FRContentAssociationUserGroupSearch";
export const ADMIN_FR_CONTENT_ASSO_DETAILS_SAVE =
  "/api/Admin/FRContentAssociations";
//End Admin -> Admin Tools -> FR Content Associations

//Admin -> Admin Tools -> Announcement Editor
export const ADMIN_ANNOUNCEMENT_EDITOR_CONTROL =
  "/api/Admin/AnnouncementEditorSearchControl";
export const ADMIN_SEARCH_ANNOUNCEMENT_EDITOR =
  "/api/Admin/AnnouncementEditorSearch";
export const ADMIN_ANNOUNCEMENT_EDITOR_CONTROLS =
  "/api/Admin/AnnouncementEditorControl";
export const ADMIN_FETCH_ANNOUNCEMENT_EDITOR = "/api/Admin/AnnouncementEditor";
export const ADMIN_SAVE_ANNOUNCEMENT_EDITOR = "/api/Admin/AnnouncementEditors";
export const ADMIN_FETCH_ANNOUNCEMENT_TARGET_USER_CONTROL =
  "/api/Admin/AnnouncementTargetUserControl";
export const ADMIN_SEARCH_ANNOUNCEMENT_TARGET_USER =
  "/api/Admin/AnnouncementTargetUserSearch";
export const ADMIN_FETCH_ANNOUNCEMENT_ADD_ALIGNMENT_CONTROL =
  "/api/Admin/AnnouncementAlignmentControl";
export const ADMIN_FETCH_ANNOUNCEMENT_ADD_FR_USERGROUP_CONTROL =
  "/api/Admin/AnnouncementUserGroupControl";

//Admin -> Admin Tools -> State Guidelines
export const ADMIN_STATE_GUIDELINES_LIST_FETCH =
  "/api/Admin/StateGuidelineList";
export const ADMIN_STATE_GUIDELINES_CONTROL_FETCH =
  "/api/Admin/StateGuidelineControl";
export const ADMIN_STATE_GUIDELINES_SAVE = "/api/Admin/StateGuidelines";
export const ADMIN_STATE_GUIDELINE_DETAILS_FETCH = "/api/Admin/StateGuideline";
//

//Admin -> Admin Tools -> FR Content Config
export const ADMIN_FR_CONTENT_CONFIG_SEARCH_CONTROL =
  "/api/Admin/FRContentConfigSearchControls";
export const ADMIN_FR_CONTENT_CONFIG_SEARCH =
  "/api/Admin/FRContentConfigSearch";
export const ADMIN_FR_CONTENT_CONFIG_CONTROL =
  "/api/Admin/FRContentConfigControl";
export const ADMIN_FR_CONTENT_CONFIG_RULE_CONTROL =
  "/api/Admin/FRContentConfigRuleControl";
export const ADMIN_FR_CONTENT_CONFIG_USER_CONTROL =
  "/api/Admin/FRContentConfigUserSearchControl";
export const ADMIN_FR_CONTENT_CONFIG_USER_SEARCH =
  "/api/Admin/FRContentConfigUserSearch";
export const ADMIN_FR_CONTENT_CONFIG_SAVE = "/api/Admin/FRContentConfigs";
export const ADMIN_FR_CONTENT_CONFIG_FETCH = "/api/Admin/FRContentConfig";
//

//Admin -> Admin Tools -> Invitation Template
export const ADMIN_INVITATION_TEMPLATE_SEARCH_CONTROL =
  "/api/Admin/InvitationTemplateSearchControl";
export const ADMIN_INVITATION_TEMPLATE_SEARCH =
  "/api/Admin/InvitationTemplateSearch";
export const ADMIN_INVITATION_TEMPLATE_FILE =
  "/api/Admin/InvitationTemplateFile";
export const ADMIN_INVITATION_TEMPLATE_CONTROL =
  "/api/Admin/InvitationTemplateControl";
export const ADMIN_INVITATION_TEMPLATE_SAVE = "/api/Admin/InvitationTemplates";
export const ADMIN_INVITATION_TEMPLATE_FETCH = "/api/Admin/InvitationTemplate";
export const ADD_EDIT_INVITATION_TEMPLATE_CONTACT_NOTE =
  "/api/Admin/InvitationTemplateContactNote";

//

//Admin -> Admin Tools -> Grouping Configuration
export const ADMIN_GROUP_CONFIG_SEARCH_CONTROL =
  "/api/Admin/GroupConfigurationSearchControl";
export const ADMIN_GROUP_CONFIG_SEARCH = "/api/Admin/GroupConfigurationSearch";
export const ADMIN_GROUP_CONFIG_CONTROL =
  "/api/Admin/GroupConfigurationControl";
export const ADMIN_GROUP_CONFIG_SAVE = "/api/Admin/GroupConfigurations";
export const ADMIN_GROUP_CONFIG_FETCH = "/api/Admin/GroupConfiguration";
//

//start Admin-> Admin tools -> AutomatedBusinessTask
export const AUTOMATED_BUSINESS_TASK_CONTROL =
  "/api/Admin/AutomatedBusinessTaskControl";
export const AUTOMATED_BUSINESS_TASK = "/api/Admin/AutomatedBusinessTask";
export const AUTOMATED_BUSINESS_TASK_DOWNLOAD =
  "/api/Admin/AutomatedBusinessTaskDownload";
export const AUTOMATED_BUSINESS_TASK_MAPPING =
  "/api/Admin/AutomatedBusinessTaskMapping";
export const SAVE_AUTOMATED_BUSINESS_TASKS =
  "/api/Admin/AutomatedBusinessTasks";
//End Admin -> Admin tools -> AutomatedBusinessTask

//start Admin-> Admin tools -> Correspondence
export const CORRESPONDENCE_SEARCH_CONTROL =
  "/api/Admin/CorrespondenceSearchControl";
export const CORRESPONDENCE_CONTROL = "/api/Admin/CorrespondenceControl";
export const CORRESPONDENCE_SEARCH = "/api/Admin/CorrespondenceSearch";
export const CORRESPONDENCE = "/api/Admin/Correspondence";
export const CORRESPONDENCE_MERGE_FIELD_LIST =
  "/api/Admin/CorrespondenceMergeFieldList";
export const CORRESPONDENCES = "/api/Admin/Correspondences";
//End Admin -> Admin tools -> Correspondence

//start Admin-> Admin tools -> Speciality Group
export const SPECIALITY_GROUP_SEARCH = "/api/Admin/SpecialityGroupSearch";
export const FETCH_SPECIALITY_GROUP = "/api/Admin/SpecialityGroup";
export const SAVE_SPECIALITY_GROUPS = "/api/Admin/SpecialityGroups";
//End Admin -> Admin tools -> Speciality Group

//start Admin-> Admin tools -> Text Message Alerts
export const TEXT_MESSAGE_ALERT_SEARCH_CONTROL =
  "/api/Admin/TextMessageAlertSearchControl";
export const TEXT_MESSAGE_ALERT_SEARCH = "/api/Admin/TextMessageAlertSearch";
export const TEXT_MESSAGE_ALERT_SUGGEST = "/api/Admin/TextMessageAlertSuggest";
export const TEXT_MESSAGE_ALERT_CONTROL = "/api/Admin/TextMessageAlertControl";
export const TEXT_MESSAGE_ALERT = "/api/Admin/TextMessageAlert";
export const SEND_ALERT_CONFIGURATION_CONTROL =
  "/api/Admin/SendAlertConfigurationControl";
export const SAVE_TEXT_MESSAGE_ALERTS = "/api/Admin/TextMessageAlerts";
//End Admin -> Admin tools -> Text Message Alerts

//start Admin-> Admin tools -> Change Activity Description
export const CHANGE_ACTIVITY_DESCRIPTION =
  "/api/Admin/ChangeActivityDescription";
export const CHANGE_ACTIVITY_DESCRIPTIONS =
  "/api/Admin/ChangeActivityDescriptions";
//End Admin -> Admin tools -> Change Activity Description

// start Admin -> Admin tools -> User Management
export const USER_MANAGEMENT_CONTROLS =
  "/api/Admin/UserManagementSearchControl";
export const SEARCH_USER_MANAGEMENT_LIST = "/api/Admin/UserManagementSearch";

// start Admin -> Admin tools -> User Group & Division Mapping
export const ADMIN_USER_GROUP_DIVISION_MAPPING_SERCH_CONTROL_GET =
  "/api/Admin/UserGroupDivisionMappingSearchControl";
export const ADMIN_GROUP_DIVISION_MAPPING_SEARCH_POST =
  "/api/Admin/UserGroupDivisionMappingSearch";
export const FETCH_ADMIN_USER_GROUP_DIVISION_MAPPING =
  "/api/Admin/UserGroupDivisionMapping";
export const USER_GROUP_DIVISION_MAPPING_CONTROL =
  "/api/Admin/UserGroupDivisionMappingControl";
export const SAVE_ADMIN_USER_GROUP_DIVISION_MAPPINGS =
  "/api/Admin/UserGroupDivisionMappings";
//End Admin -> Admin tools -> User Group & Division Mapping

// start Admin -> Activity Configuration -> Activity Assignment
export const ACTIVITY_FACULTY_DETAILS = "/api/Activity/FacultyDetail";
export const ACTIVITY_ASSIGNMENT_SEARCH = "/api/Admin/ActivityAssignmentSearch";
export const FETCH_ACTIVITY_ASSIGNMENT = "/api/Admin/ActivityAssignment";
export const ACTIVITY_ASSIGNMENT_CONTROL =
  "/api/Admin/ActivityAssignmentControl";
export const ACTIVITY_ASSIGNMENT_FACULTY_SEARCH =
  "/api/Admin/ActivityAssignmentFacultySearch";
export const ACTIVITY_ASSIGNMENT_FACULTY_SEARCH_CONTROL =
  "/api/Admin/ActivityAssignmentFacultySearchControl";
export const ACTIVITY_ASSIGNMENT_REASSIGN =
  "/api/Admin/ActivityAssignmentReassign";
export const SAVE_ACTIVITY_ASSIGNMENTS = "/api/Admin/ActivityAssignments";
//End Admin -> Activity Configuration -> Activity Assignment

// start Admin -> Activity Configuration -> Activity Auto-Cancel
export const ACTIVITY_AUTO_CANCEL_SEARCH_CONTROL =
  "/api/Admin/ActivityAutoCancelSearchControl";
export const ACTIVITY_AUTO_CANCEL_SUGGEST =
  "/api/Admin/ActivityAutoCancelSuggest";
export const FETCH_ACTIVITY_AUTO_CANCEL_SEARCH =
  "/api/Admin/ActivityAutoCancelSearch";
export const ACTIVITY_AUTO_CANCEL_CONTROL =
  "/api/Admin/ActivityAutoCancelControl";
export const FETCH_ACTIVITY_AUTO_CANCEL = "/api/Admin/ActivityAutoCancel";
export const SAVE_ACTIVITY_AUTO_CANCEL = "/api/Admin/ActivityAutoCancels";
//End Admin -> Activity Configuration -> Activity Auto-Cancel

// start Admin -> Activity Configuration -> Activity Description
export const ACTIVITY_DESCRIPTION_SEARCH_CONTROL =
  "/api/Admin/ActivityDescriptionSearchControl";
export const FETCH_ACTIVITY_DESCRIPTION_SEARCH =
  "/api/Admin/ActivityDescriptionSearch";
export const ACTIVITY_DESCRIPTION_LEGAL_LANGUAGE =
  "/api/Admin/ActivityDescriptionLegalLanguage";
export const ACTIVITY_DESCRIPTION_LEGAL_LANGUAGES =
  "/api/Admin/ActivityDescriptionLegalLanguages";
export const ACTIVITY_DESCRIPTION_TRAVEL_TYPE =
  "/api/Admin/ActivityDescriptionTravelType";
export const ACTIVITY_DESCRIPTION_TRAVEL_TYPES =
  "/api/Admin/ActivityDescriptionTravelTypes";
export const ACTIVITY_DESCRIPTION_CONTROL =
  "/api/Admin/ActivityDescriptionControl";
export const ACTIVITY_DESCRIPTION = "/api/Admin/ActivityDescription";
export const SAVE_ACTIVITY_DESCRIPTIONS = "/api/Admin/ActivityDescriptions";
export const ACTIVITY_DESCRIPTION_REFRESH_COMMENTS =
  "/api/Admin/ActivityDescriptionComment";
export const ACTIVITY_DESCRIPTION_DELETE_COMMENTS =
  "/api/Admin/ActivityDescriptionComments";
export const ACTIVITY_DESCRIPTION_WORKFLOW_CONFIGURATION =
  "/api/Admin/ActivityDescriptionWorkflowConfiguration";
export const ACTIVITY_DESCRIPTION_WORKFLOW_CONFIGURATIONS =
  "/api/Admin/ActivityDescriptionWorkflowConfigurations";
export const ACTIVITY_DESCRIPTION_FINANCIAL_CATEGORY_CONTROL =
  "/api/Admin/FinancialCategoryControl";
export const ACTIVITY_DESCRIPTION_FINANCIAL_CATEGORY_PRIMARY =
  "/api/Admin/FinancialCategoryPrimary";
export const ACTIVITY_DESCRIPTION_FINANCIAL_CATEGORY_SECONDARY =
  "/api/Admin/FinancialCategorySecondary";
export const ACTIVITY_DESCRIPTION_FINANCIAL_CATEGORY =
  "/api/Admin/FinancialCategory";
export const ACTIVITY_DESCRIPTION_FINANCIAL_CATEGORIES =
  "/api/Admin/FinancialCategories";

//End Admin -> Activity Configuration -> Activity Description

//start Admin -> Admin tools -> Rep Evaluation Config
export const REP_EVALUATION_CONFIG_SEARCH =
  "/api/Admin/RepEvaluationConfigSearch";
export const REP_EVALUATION_CONFIG_FILE = "/api/Admin/RepEvaluationConfigFile";
export const REP_EVALUATION_CONFIG = "/api/Admin/RepEvaluationConfig";
export const REP_EVALUATION_CONFIG_SAVE = "/api/Admin/RepEvaluationConfigs";
//

//start Admin -> Admin tools -> Budget Exemption
export const BUDGET_EXPEMPTION_SEARCH = "/api/Admin/BudgetExemptionSearch";
export const BUDGET_EXPEMPTION_DELETE = "/api/Admin/BudgetExemptionDelete";
export const BUDGET_EXPEMPTION_CONTROLS = "/api/Admin/BudgetExemptionControl";
export const BUDGET_EXPEMPTION_SAVE = "/api/Admin/BudgetExemptions";
export const BUDGET_EXPEMPTION_FETCH = "/api/Admin/BudgetExemption";

// start Admin -> Admin tools -> User Management
export const GET_USER_MANAGEMENT_COMMENT = "/api/Admin/UserManagementComment";
export const SAVE_USER_MANAGEMENT_COMMENT = "/api/Admin/UserManagementComments";
export const USER_MANAGEMENT_ACCOUNT_RESET_PASSWORD =
  "/api/Admin/UserManagementAccountResetPassword";
export const USER_MANAGEMENT_ACCOUNT_EMAIL_PASSWORD =
  "/api/Admin/UserManagementAccountEmailPassword";
export const USER_MANAGEMENT_ACCOUNT_EMAIL_USERID =
  "/api/Admin/UserManagementAccountEmailUserId";
export const USER_MANAGEMENT_ACCOUNT_RESER_SECURITY_QUESTION =
  "/api/Admin/UserManagementAccountResetSecurityQuestion";
export const FETCH_USER_MANAGEMENT_ACCOUNT_MFA =
  "/api/Admin/UserManagementAccountMFA";
export const SAVE_USER_MANAGEMENT_ACCOUNT_MFA =
  "/api/Admin/UserManagementAccountMFAs";
export const USER_MANAGEMENT_NEW_USER_ACCOUNT_CONTROLLER =
  "/api/Admin/UserManagementNewUserControl";
export const SAVE_USER_MANAGEMENT_NEW_USER_ACCOUNT =
  "/api/Admin/UserManagementNewUsers";
export const SEARCH_FR_USER_MANAGEMENT_LIST =
  "/api/Admin/UserManagementFRUserSearch";
export const GET_FR_USER_MANAGEMENT_DATA = "/api/Admin/UserManagementFRUser";
export const SEARCH_USER_MANAGEMENT_ALIGNMENT =
  "/api/Admin/UserManagementAlignmentSearch";
export const SHOW_USER_MANAGEMENT_TABS = "/api/Admin/UserManagementTab";
export const SAVE_NEW_USER_MANAGEMENT = "/api/Admin/UserManagementNewUsers";
export const SAVE_EDIT_USER_MANAGEMENT = "/api/Admin/UserManagementAccounts";
export const GET_USER_MANAGEMENT_USER_ACCOUNT =
  "/api/Admin/UserManagementAccount";
export const GET_USER_MANAGEMENT_USER_PROFILE =
  "/api/Admin/UserManagementProfile";
export const SAVE_USER_MANAGEMENT_USER_PROFILE =
  "/api/Admin/UserManagementProfiles";
export const GET_USER_MANAGEMENT_PROFILE_ALIGNMENT =
  "/api/Admin/UserManagementProfileAlignment";
export const GET_USER_MANAGEMENT_ASSIGN_GROUP_CONTROLLER =
  "/api/Admin/UserManagementAssignGroup";
export const SAVE_USER_MANAGEMENT_ASSIGN_GROUP =
  "/api/Admin/UserManagementAssignGroups";

// start Admin -> Activity Configuration -> Expense Management
export const EXPENSE_MANAGEMENT_SEARCH_CONTROLLER =
  "/api/Admin/ExpenseManagementSearchControl";
export const EXPENSE_MANAGEMENT_SEARCH = "/api/Admin/ExpenseManagementSearch";
export const GET_EXPENSE_MANAGEMENT_DETAILS_CONTROLLER =
  "/api/Admin/ExpenseManagementControl";
export const GET_EXPENSE_MANAGEMENT_DETAILS = "/api/Admin/ExpenseManagement";
export const SAVE_EXPENSE_MANAGEMENT_DETAILS = "/api/Admin/ExpenseManagements";

// start Admin -> Activity Configuration -> Honorarium Management Advising
export const HONORARIUM_MANAGEMENT_ADV_SEARCH_CONTROL =
  "/api/Admin/HonorariumManagementAdvisingSearchControl";
export const HONORARIUM_MANAGEMENT_ADV_SEARCH =
  "/api/Admin/HonorariumManagementAdvisingSearch";
export const HONORARIUM_MANAGEMENT_ADV_CONTROL =
  "/api/Admin/HonorariumManagementAdvisingControl";
export const HONORARIUM_MANAGEMENT_ADV_DETAILS =
  "/api/Admin/HonorariumManagementAdvising";
export const HONORARIUM_MANAGEMENT_ADV_SAVE =
  "/api/Admin/HonorariumManagementAdvisings";

// start Admin -> Activity Configuration -> Faculty Selection
export const GET_FACULTY_SELECTION_CONTROLLER =
  "/api/Admin/FacultySelectionControl";
export const SEARCH_FACULTY_SELECTION = "/api/Admin/FacultySelectionSearch";
export const GET_FACULTY_SELECTION = "/api/Admin/FacultySelection";
export const SAVE_FACULTY_SELECTION = "/api/Admin/FacultySelections";

//Admin -> Activity Configuration -> Attendee Program Block
export const FETCH_ATTENDEE_PROGRAM_BLOCK_CONTROLS =
  "/api/Admin/AttendeeProgramBlockControl";
export const FETCH_ATTENDEE_TRAINED_RULE_DETAILS =
  "/api/Admin/AttendeeTrainedRule";
export const FETCH_FACULTY_ATTENDEE_RULE_DETAILS =
  "/api/Admin/FacultyAttendeeRule";
export const SAVE_ATTENDEE_TRAINED_RULE_DETAILS =
  "/api/Admin/AttendeeTrainedRules";
export const SAVE_FACULTY_ATTENDEE_RULE_DETAILS =
  "/api/Admin/FacultyAttendeeRules";
export const ATTENDEE_PROGRAM_CAP_RULE_SEARCH_CONTROL =
  "/api/Admin/AttendeeProgramCapRuleSearchControl";
export const ATTENDEE_PROGRAM_CAP_RULE_SEARCH =
  "/api/Admin/AttendeeProgramCapRuleSearch";
export const ATTENDEE_PROGRAM_CAP_RULE_CONTROL =
  "/api/Admin/AttendeeProgramCapRuleControl";
export const ATTENDEE_PROGRAM_CAP_RULE = "/api/Admin/AttendeeProgramCapRule";
export const ATTENDEE_PROGRAM_CAP_RULES = "/api/Admin/AttendeeProgramCapRules";

// start Admin -> Activity Configuration -> Tier - Brand Mapping
export const TIER_BRAND_MAPPING_SEARCH_CONTROL =
  "/api/Admin/TierBrandMappingSearchControl";
export const TIER_BRAND_MAPPING_SEARCH = "/api/Admin/TierBrandMappingSearch";
export const TIER_BRAND_MAPPING_CONTROL = "/api/Admin/TierBrandMappingControl";
export const TIER_BRAND_MAPPING_DETAIL = "/api/Admin/TierBrandMapping";
export const TIER_BRAND_MAPPING_SAVE = "/api/Admin/TierBrandMappings";

//start Admin -> Activity Configuration -> Medical Tier Admin
export const MEDICAL_TIER_ADMIN_CONTROL = "/api/Admin/MedicalTierAdminControl";
export const MEDICAL_TIER_ADMIN_SEARCH = "/api/Admin/MedicalTierAdmin";
export const MEDICAL_TIER_ADMIN_SAVE = "/api/Admin/MedicalTierAdmins";
export const ACTIVITY_FACULTY_TIERS = "/api/Activity/FacultyTiers";

//Admin -> Activity Configuration -> Activity Rule
export const ACTIVITY_RULE_SEARCH_CONTROL =
  "api/Admin/ActivityRuleSearchControl";
export const ACTIVITY_RULE_SEARCH = "api/Admin/ActivityRuleSearch";
export const ACTIVITY_RULE_TOWN_SUGGEST = "api/Admin/ActivityRuleTownSuggest";
export const ACTIVITY_RULE_FACULTY_SUGGEST =
  "api/Admin/ActivityRuleFacultySuggest";
export const ACTIVITY_RULE_ACTIVITYID = "api/Admin/ActivityRuleActivityId";
export const ACTIVITY_RULE_DOWNLOAD = "api/Admin/ActivityRuleDownload";
export const SALES_ORG_RESTRICTION_CONTROL =
  "api/Admin/SalesOrgRestrictionControl";
export const SALES_ORG_RESTRICTION_SEARCH =
  "api/Admin/SalesOrgRestrictionSearch";
export const SALESFORCE_ACCESS_CONTROL = "api/Admin/SalesForceAccessControl";
export const SALESFORCE_ACCESS_SEARCH = "api/Admin/SalesForceAccessSearch";
export const ACTIVITY_RULE_CONTROL = "api/Admin/ActivityRuleControl";
export const ACTIVITY_RULE = "api/Admin/ActivityRule";
export const ACTIVITY_RULES = "api/Admin/ActivityRules";
//END

//Admin -> Activity Configuration -> Homorarium Travel
export const HONORARIUM_TRAVEL_SEARCH_CONTROL =
  "/api/Admin/HonorariumTravelSearchControl";
export const HONORARIUM_TRAVEL_SEARCH = "/api/Admin/HonorariumTravelSearch";
export const HONORARIUM_TRAVEL_CONTROL = "/api/Admin/HonorariumTravelControl";
export const HONORARIUM_TRAVEL_DATA = "/api/Admin/HonorariumTravel";
export const SAVE_HONORARIUM_TRAVELS_DATA = "/api/Admin/HonorariumTravels";
//END

//Admin -> Activity Configuration -> Homorarium Admin
export const HONORARIUM_ADMIN_SEARCH_CONTROL =
  "/api/Admin/HonorariumAdminSearchControl";
export const HONORARIUM_ADMIN_SEARCH = "/api/Admin/HonorariumAdminSearch";
export const HONORARIUM_ADMIN_CONTROL = "/api/Admin/HonorariumAdminControl";
export const HONORARIUM_ADMIN_DATA = "/api/Admin/HonorariumAdmin";
export const HONORARIUM_ADMIN_EXTEND_TIER =
  "/api/Admin/HonorariumAdminExtendTier";
export const HONORARIUM_ADMIN_COPY_TIER = "/api/Admin/HonorariumAdminCopyTier";
export const HONORARIUM_ADMIN_DOWNLOAD = "/api/Admin/HonorariumAdminDownload";
export const SAVE_HONORARIUM_ADMIN_DATA = "/api/Admin/HonorariumAdmins";
//END

//start Admin ->  Activity Configuration -> Honorarium Management FDA
export const HONORARIUM_MGMT_FDA_SEARCH_CONTROL =
  "/api/Admin/HonorariumManagementFDASearchControl";
export const HONORARIUM_MGMT_FDA_SEARCH =
  "/api/Admin/HonorariumManagementFDASearch";
export const HONORARIUM_MGMT_FDA_CONTROL =
  "/api/Admin/HonorariumManagementFDAControl";
export const HONORARIUM_MGMT_FDA_DETAIL = "/api/Admin/HonorariumManagementFDA";
export const HONORARIUM_MGMT_FDA_SAVE = "/api/Admin/HonorariumManagementFDAs";

//start Admin ->  Activity Configuration -> Honorarium Management Medical
export const HONORARIUM_MGMT_MEDICAL_SEARCH_CONTROL =
  "/api/Admin/HonorariumManagementMedicalSearchControl";
export const HONORARIUM_MGMT_MEDICAL_SEARCH =
  "/api/Admin/HonorariumManagementMedicalSearch";
export const HONORARIUM_MGMT_MEDICAL_CONTROLS =
  "/api/Admin/HonorariumManagementMedicalControl";
export const HONORARIUM_MGMT_MEDICAL_DETAILS =
  "/api/Admin/HonorariumManagementMedical";
export const HONORARIUM_MGMT_MEDICAL_SAVE =
  "/api/Admin/HonorariumManagementMedicals";

//start Activity
export const ACTIVITY_PERMISSION = "/api/Activity/Permission";
export const ACTIVITY_LOAD_ACTIVITY = "/api/Activity/LoadActivity";

//start Activity -> ARF
export const REQUEST_FORM_CONTROL = "/api/Activity/RequestFormControl";
export const REQUEST_FORM_TL_MAP_SEARCH =
  "/api/Activity/RequestFormTLMaPSearch";
export const FETCH_REQUEST_FORM = "/api/Activity/RequestForm";
export const REQUEST_FORM_NOTES = "/api/Activity/RequestFormNotes";
export const REQUEST_FORM_ATTACHMENTS = "/api/Activity/RequestFormAttachments";
export const FETCH_REQUEST_FORM_ATTACHMENT =
  "/api/Activity/RequestFormAttachment";
export const REQUEST_FORM_ATTACHMENT_FILE =
  "/api/Activity/RequestFormAttachmentFile";
export const FETCH_GOOGLE_ADDRESS = "/api/Common/GoogleAddress";
export const SAVE_REQUEST_FORMS = "/api/Activity/RequestForms";
export const VERIFY_GOOGLE_RE_CAPTCHA = "/api/Common/GoogleReCaptcha";
export const ACTIVITY_HCP_REGISTRATION_ADMIN_ENDPOINT =
  "API/Activity/HCPRegistrationAdmin";
export const ACTIVITY_HCP_REGISTRATION_ADMIN_PREVIEW_ENDPOINT =
  "API/Activity/HCPRegistrationAdminPreview";
export const ACTIVITY_HCP_REGISTRATION_ADMIN_SAVE_ENDPOINT =
  "API/Activity/HCPRegistrationAdmins";
//end
//start Admin ->  Survey -> Survey Question
export const QUESTION_LIST_CONTROL = "/api/Admin/QuestionListControl";
export const QUESTION_LIST_SEARCH = "/api/Admin/QuestionList";
export const SURVEY_QUESTION_CONTROL = "/api/Admin/QuestionControl";
export const SURVEY_QUESTIONS = "/api/Admin/Questions";
export const SURVEY_QUESTION = "/api/Admin/Question";
export const SURVEY_CONTACT_NOTE = "/api/Admin/SurveyContactNote";
export const SURVEYBU_LIST_CONTROL = "/api/Admin/SurveyBUListControl";
export const SURVEY_BU_CONTROL = "/api/Admin/SurveyBUControl";
export const SURVEY_BUS = "/api/Admin/SurveyBUs";
export const SURVEY_BU = "/api/Admin/SurveyBU";
export const SURVEY_BU_LOADFACULTY = "/api/Admin/SurveyBULoadFaculty";
export const SURVEY_BU_DOWNLOAD = "/api/Admin/SurveyBUDownload";
export const SURVEY_BUDELETE = "/api/Admin/SurveyBUDelete";
export const SURVEY_BU_LIST_SEARCH = "/api/Admin/SurveyBUList";
export const SURVEY_LIST_CONTROL = "/api/Admin/SurveyListControl";
export const SURVEY_CONFIGURATIONS = "/api/Admin/SurveyConfigurations";
export const SURVEY_CONFIGURATION = "/api/Admin/SurveyConfiguration";
export const SURVEY_FRTARGETUSERS_CONTROL =
  "/api/Admin/SurveyFRTargetUsersControl";
export const SURVEY_TARGETUSERS_CONTROL =
  "/api/Admin/SurveyTUConfigForCPPControl";
export const SURVEY_CONFIGURATION_CONTROL =
  "/api/Admin/SurveyConfigurationControl";
export const SURVEY_SEARCH_FRTARGETUSERS = "/api/Admin/SearchFRTargetUser";
export const SURVEY_SEARCH_TARGETUSERS = "/api/Admin/SearchCPPTargetUser";
export const SURVEY_FETCH_FRTARGETUSERBUDETAILS =
  "/api/Admin/FetchFRTargetUserBUDetails";
export const SURVEY_FETCH_TARGETUSERDETAILS =
  "/api/Admin/FetchCPPTargetUserDetails";
export const SURVEY_STATS_SEARCH = "/api/Admin/FetchSurveyDashboardStats";
export const SURVEY_CONFIGURATION_LIST_SEARCH =
  "/api/Admin/SurveyConfigurationList";
export const SURVEY_TARGETUSER_STATUS = "/api/Admin/SurveyTargetUserStatus";
export const SURVEY_TARGETUSER_DOWNLOAD = "/api/Admin/SurveyTargetUserDownload";
export const SURVEY_TU_DELETE_COMMENT = "/api/Admin/SurveyTargetsDeleteComment";
export const SURVEY_DATATRANSFORM_STATS_SEARCH =
  "/api/Admin/FetchSurveyDashboardDataTransformStats";
export const SURVEY_COPY_CAMPAIGN = "/api/Admin/FetchCopyCampaignDetails";

export const FETCH_PARTICIPANT_FORM = "/api/Activity/AddParticipantControl";
export const SEARCH_PARTICIPANT = "/api/Activity/ParticipantSearch";
export const FETCH_PARTICIPANT_CV_FILE = "/api/Activity/FetchParticipantCVFile";
export const FETCH_SURVEY_QUESTION = "/api/Dashboard/SurveyQuestion";
export const SAVE_SURVEY_QUESTIONS = "/api/Dashboard/SurveyQuestions";
export const FETCH_INSTRUCTION_TEXT = "/api/Admin/QuestionInstructionText";
export const SURVEY_QUESTION_DELETE = "/api/Admin/SurveyQuestionDelete";
export const FETCH_SURVEY_EMAIL_NOTIFICATION =
  "/api/Admin/FetchSurveyEmailNotification";
export const SURVEY_DELETE_TARGETUSERS = "/api/Admin/DeleteSurveyTargetUsers";
//end

// start Admin -> Admin Tools -> Expense Approval Configuration
export const EXPENSE_APPROVAL_CONFIGURATION_SEARCH_CONTROL =
  "/api/Admin/ExpApprovalConfigSearchControl";
export const EXPENSE_APPROVAL_CONFIGURATION_SEARCH = "/api/Admin/ExpApprovalConfigSearch";

export const GET_EXPENSE_APPROVAL_CONFIGURATION_DETAILS_CONTROLLER =
  "/api/Admin/ExpApprovalConfigControl";
export const GET_EXPENSE_APPROVAL_CONFIGURATION_DETAILS = "/api/Admin/ExpApprovalConfig";
export const SAVE_EXPENSE_APPROVAL_CONFIGURATION_DETAILS = "/api/Admin/ExpApprovalConfigs";
export const GET_EXPENSE_EXCEPTION_CONFIG_DETAILS = "/api/Admin/ExpenseExceptionConfiguration";
export const SAVE_EXPENSE_EXCEPTION_CONFIG_DETAILS = "/api/Admin/ExpenseExceptionConfigurations";
//end
//start Activity -> ORF
export const ARF_FORM_CONTROL = "/api/Activity/ARFFormControl";
export const ARF_FORM_FACULTY = "/api/Activity/ARFFormFaculty";
export const ARF_FORM_ACTIVITY = "/api/Activity/ARFFormActivity";
export const ARF_FORM_SAVE = "/api/Activity/ARFForms";
export const ARF_FORM_DETAIL = "/api/Activity/ARFForm";

//start Activity -> Invoice Detail
export const INVOICE_DETAIL_CONTROL = "/api/Activity/InvoiceDetailControl";
export const INVOICE_DETAIL_SEARCH = "/api/Activity/InvoiceDetailSearch";
export const INVOICE_DETAIL_DELETE = "/api/Activity/InvoiceDetailDelete";
export const INVOICE_DETAIL_FACULTY_SEARCH =
  "/api/Activity/InvoiceDetailFacultySearch";
export const INVOICE_DETAIL_FACULTY = "/api/Activity/InvoiceDetailFaculty";
export const INVOICE_DETAIL_HISTORY = "/api/Activity/InvoiceDetailHistory";
export const INVOICE_DETAIL = "/api/Activity/InvoiceDetail";
export const INVOICE_DETAIL_DOWNLOAD = "/api/Activity/InvoiceFileDownload";
export const SAVE_INVOICE_DETAILS = "/api/Activity/InvoiceDetails";
//end

//start Activity -> Pymt Mgmt Tools -> Add Expense Detail
export const EXPENSE_DETAILS_CONTROL = "/api/Activity/ExpenseDetailControl";
export const EXPENSE_DETAILS_SEARCH = "/api/Activity/ExpenseDetailSearch";
export const EXPENSE_DETAILS_DELETE = "/api/Activity/ExpenseDetailDelete";
export const EXPENSE_DETAILS_HISTORY = "/api/Activity/ExpenseDetailHistory";
export const EXPENSE_REJECTION_REASONS = "/api/Activity/AutomateExpenseRejectionReason";
export const EXPENSE_DETAILS_FACULTY_SEARCH =
  "/api/Activity/ExpenseDetailFacultySearch";
export const EXPENSE_DETAILS_FACULTY = "/api/Activity/ExpenseDetailFaculty";
export const EXPENSE_DETAILS_FACULTY_EXCEPTION_CONTROL =
  "/api/Activity/ExpenseDetailFacultyExceptionControl";
export const EXPENSE_DETAILS_FACULTY_EXCEPTION =
  "/api/Activity/ExpenseDetailFacultyException";
export const EXPENSE_DETAILS_FACULTY_EXCEPTIONS_SAVE =
  "/api/Activity/ExpenseDetailFacultyExceptions";
export const EXPENSE_DETAILS = "/api/Activity/ExpenseDetail";
export const EXPENSE_FILE_DOWNLOAD = "/api/Activity/ExpenseFileDownload";
export const EXPENSE_SAVE = "/api/Activity/ExpenseDetails";
export const EXPENSE_DETAIL_DOWNLOAD = "/api/Activity/ExpenseDetailDownload";
export const DUPLICATE_EXPENSE_DETAIL = "/api/Activity/DuplicateExpenseDetail";

//start Activity -> Add Comment Pop Up
export const FETCH_ACTIVITY_COMMENT = "/api/Activity/ActivityComment";
export const ACTIVITY_COMMENTS = "/api/Activity/ActivityComments";
//end

//start Activity -> Activity History
export const ACTIVITY_HISTORY = "/api/Activity/ActivityHistory";
//end

//start Activity -> Activity History
export const ACTIVITY_FACULTIES = "/api/Activity/ActivityFaculties";
//end

//Activity -> View Itinerary
export const VIEW_ITINERARY_PNR = "/api/Activity/PNR";

// Activity -> Expense Correspondence Search
export const ACTIVITY_EXPENSE_CORRESPONDENCE_CONTROL =
  "/api/Activity/ExpenseCorrespondenceSearchControl";
export const ACTIVITY_EXPENSE_CORRESPONDENCE_SEARCH =
  "/api/Activity/ExpenseCorrespondenceSearch";
export const FETCH_EXPENSE_CORRESPONDENCE_DETAILS =
  "/api/Activity/ExpenseCorrespondence";
export const SAVE_EXPENSE_CORRESPONDENCE_DETAILS =
  "/api/Activity/ExpenseCorrespondences";

// Activity -> Basic Search ARF
export const ARF_BASIC_SEARCH_CONTROL = "/api/Activity/ARFBasicSearchControl";
export const ARF_BASIC_SEARCH_RESULT = "/api/Activity/ARFBasicSearch";
export const ARF_ADVANCE_SEARCH_CONTROL =
  "/api/Activity/ARFAdvancedSearchControl";
export const ARF_ADVANCE_SEARCH_RESULT = "/api/Activity/ARFAdvancedSearch";
export const PID_SEARCH = "/api/Activity/PIDSearch";
export const PNR_GENERATE = "/api/Activity/PNRGenerate";

// Activity -> Activity Basic Search
export const ACTIVITY_BASIC_SEARCH_CONTROL =
  "/api/Activity/ActivityBasicSearchControl";
export const ACTIVITY_BASIC_SEARCH_RESULT = "/api/Activity/ActivityBasicSearch";
export const ACTIVITY_ADVANCE_SEARCH_CONTROL =
  "/api/Activity/ActivityAdvancedSearchControl";
export const ACTIVITY_ADVANCE_SEARCH_RESULT =
  "/api/Activity/ActivityAdvancedSearch";
//Activity -> Multiple Activities Pop up
export const MULTIPLE_FACULTY_ACTIVITIES =
  "/api/Activity/MultipleFacultyActivities";

//Activity -> Activity Map
export const ACTIVITY_MAP_CONTROLS = "/api/Activity/ActivityMapControl";
export const ACTIVITY_MAP_FILTER = "/api/Activity/ActivityMapFilter";

//Activity -> Send Correspondence
export const SEND_CORRESPONDENCE = "/api/Activity/SendCorrespondence";
export const SEND_CORRESPONDENCE_BRAND =
  "/api/Activity/SendCorrespondenceBrand";
export const SEND_CORRESPONDENCE_EMAIL =
  "/api/Activity/SendCorrespondenceEmail";
export const SEND_CORRESPONDENCE_EMAILS =
  "/api/Activity/SendCorrespondenceEmails";

//Activity -> Directions
export const ACTIVITY_DIRECTION_SEARCH =
  "/api/Activity/ActivityDirectionSearch";
export const ACTIVITY_DIRECTION_SEARCH_CONTROLS =
  "/api/Activity/ActivityDirectionSearchControl";
export const ACTIVITY_DIRECTION = "/api/Activity/ActivityDirection";

//Activity -> Check Status
export const CHECK_STATUS_DETAILS = "/api/Activity/CheckStatus";
export const CHECK_STATUS_EXPENSE_FORM_DOWNLOAD =
  "/api/Activity/ExpenseFormDownload";
export const CHECK_TYPE_REISSUE = "/api/Activity/CheckTypeReissue";
export const CHECK_STATUS_DOWNLOAD = "/api/Activity/CheckStatusDownload";

//Activity -> Activity Meetings
export const ACTIVITY_MEETING_LIST = "/api/Activity/ActivityMeetingList";
export const ACTIVITY_MEETING_LIST_SAVE = "/api/Activity/ActivityMeetingLists";
export const ACTIVITY_MEETING_DELETE = "/api/Activity/ActivityMeetingDelete";
export const ACTIVITY_MEETING_HCP_REGISTRATION_RESET =
  "/api/Activity/HCPRegistrationReset";
export const COST_CATEGORY_ALLOCATION_FETCH =
  "/api/Activity/CostCategoryAllocation";
export const COST_CATEGORY_ALLOCATION_SAVE =
  "/api/Activity/CostCategoryAllocations";
export const ACTIVITY_MEETING = "/api/Activity/ActivityMeeting";
export const GOOGEL_ADDRESS_VALIDATE = "/api/Common/GoogleAddressValidate";
export const ACTIVITY_MEETING_SAVE = "/api/Activity/ActivityMeetings";
//Activity -> InfoSheet Popup
export const ACTIVITY_INFOSHEET_MEDICAL =
  "/api/Activity/ActivityInfosheetMedical";
export const ACTIVITY_INFOSHEET_LTS = "/api/Activity/ActivityInfosheetLTS";
export const ACTIVITY_INFOSHEET_BRAND = "/api/Activity/ActivityInfosheetBrand";
export const ACTIVITY_INFOSHEET_FEEDBACK =
  "/api/Activity/ActivityInfosheetFeedback";
export const ACTIVITY_INFOSHEET = "/api/Activity/ActivityInfosheet";
export const ACTIVITY_INFOSHEET_FIELD_LTS =
  "/api/Activity/ActivityInfosheetFieldLTS";
// Activity -> Activity Calendar
export const ACTIVITY_CALENDAR_CONTROL =
  "/api/Activity/ActivityCalendarControl";
export const ACTIVITY_CALENDAR_FILTER = "/api/Activity/ActivityCalendarFilter";
export const ACTIVITY_CALENDAR = "/api/Activity/ActivityCalendar";

// Activity -> Medical Activity
export const MEDICAL_ACTIVITY_CONTROL = "/api/Activity/MedicalActivityControl";
export const MEDICAL_ACTIVITY_INFORMATION =
  "/api/Activity/MedicalActivityInformation";
export const MEDICAL_ACTIVITY_CONSULTANT_STATUS_LEGEND =
  "/api/Activity/ConsultantStatusLegend";
export const MEDICAL_ACTIVITY_BUDGET_APPROVERS =
  "/api/Activity/MedicalActivityBudgetAndApprovers";
export const MEDICAL_CONSULTANTS_SEARCH = "/api/Activity/ConsultantSearch";
export const MEDICAL_ACTIVITY_APPROVAL_STATUS = "/api/Activity/ApprovalStatus";
export const MEDICAL_CONSULTANT_APPROAL_STATUS =
  "/api/Activity/ConsultantApprovalStatus";
export const MEDICAL_ACTIVITY_TRIALALIAS = "/api/Activity/TrialAlias";
export const MEDICAL_ACTIVITY_SAVE = "/api/Activity/MedicalActivitySave";
export const CONSULTANT_SEARCH_CONTROL =
  "/api/Activity/ConsultantSearchControl";
export const NEW_CONSULTANT_CONTROL = "/api/Activity/NewConsultantControl";
export const VALIDATE_CONSULTANTS = "/api/Activity/ValidateConsultant";
export const MEDICAL_RESET_CONSULTANT_ROLE =
  "/api/Activity/ResetConsultantRole";
export const MEDICAL_ACTIVITY_BUDGET_APPROVERS_CONTROL =
  "/api/Activity/MedicalActivityBudgetApproverControl";
export const COST_CENTER = "/api/Activity/CostCenter";
export const MEDICAL_CONTRACT_PREVIEW = "/api/Activity/MedicalContractPreview";
export const MEDICAL_ACTIVITY_INFORMATIONS =
  "/api/Activity/MedicalActivityInformations";
export const FACULTY_CONTRACT_AVAILABLE =
  "/api/Activity/FacultyContractAvailable";
export const CONSULTANT_CONTRACT_INFO_CONTROL =
  "/api/Activity/ConsultantContractInformationControl";
export const CONSULTANT_TERMINATION_CONTROL =
  "/api/Activity/ConsultantTerminationControl";
export const CONSULTANT_CANCELLATION_CONTROL =
  "/api/Activity/ConsultantCancellationControl";
// Activity -> Common API
export const ACTIVITY_TYPE = "/api/Activity/ActivityType";
export const LOAD_ACTIVITY = "/api/Activity/LoadActivity";

// Activity -> AdvisingActivityInformation
export const FEEDBACK_ACTIVITY_INFORMATION =
  "/api/Activity/FeedbackActivityInformation";
export const ADVISING_ACTIVITY_APPROVAL_STATUS =
  "/api/Activity/AdvisingActivityApprovalStatus";
export const ADVISING_ACTIVITY_COST_CENTER_HISTORY =
  "/api/Activity/AdvisingActivityCostCenterHistory";
export const GET_ARF = "/api/Activity/ARF";
export const CHECK_ARF = "/api/Activity/CheckARF";
export const SAVE_FEEDBACK_ACTIVITY_INFORMATION =
  "/api/Activity/FeedbackActivityInformations";
export const CHECK_ACTIVITY_DESCRIPTION =
  "/api/Activity/CheckActivityDescription";
export const CHECK_INDIVIDUAL_PAYMENTS_LIMIT =
  "/api/Activity/CheckIndividualPaymentsLimit";

// Activity -> FeedbackActivityLocation
export const FEEDBACK_ACTIVITY_LOCATION_CONTROL =
  "/api/Activity/FeedbackLocationControl";
export const CHECK_FACULTY_OUS_AMOUNT = "/api/Activity/CheckFacultyOUSAmount";

// Activity -> FeedbackActivityLocation
export const FEEDBACK_ACTIVITY_COMMENT_CONTROL =
  "/api/Activity/FeedbackCommentControl";

// Activity -> FeedbackActivityParticipant Info
export const FEEDBACK_ACTIVITY_PARTICIPANT_INFO_CONTROL =
  "/api/Activity/FeedbackParticipantControl";
export const FACULTY_DOCUMENT = "/api/Activity/FacultyDocument";
export const ADD_ARF_PARTICIPANT = "/api/Activity/AddARFParticipant";
export const NON_MEDICAL_PERSONNEL_SEARCH =
  "/api/Activity/NonMedicalPersonnelSearch";
export const ACTIVITY_SEARCH_FACULTY_CONTROLS =
  "/api/Activity/ActivitySearchFacultyControls";
export const ACTIVITY_SEARCH_FACULTY = "/api/Activity/ActivitySearchFaculty";

// Activity -> Advisory Description Information
export const FEEDBACK_ADVISORY_CONTROL =
  "/api/Activity/FeedbackAdvisoryControl";

// Activity -> Add Field Activity
export const ACTIVITY_INFORMATION_CONTROL =
  "/api/FieldActivity/ActivityInformationControl";
export const ACTIVITY_DATETIME_CONTROL =
  "/api/Activity/ActivityDateTimeControl";
export const ACTIVITY_BUSINESS_JUSTIFICATION_CONTROL =
  "/api/Activity/BusinessJustification";
export const ACTIVITY_TRAVEL_CONTROL = "/api/Activity/ActivityTravelControl";
export const ACTIVITY_PROGRAM_VALIDATION_CONTROL =
  "/api/Activity/FieldProgramValidationControl";
export const ACTIVITY_INFO_DETAILS = "/api/FieldActivity/ActivityDetail";

// Activity -> Payment Request
export const ACTIVITY_GET_PAYMENT_REQUEST = "/api/Activity/PaymentRequest";
export const ACTIVITY_SAVE_PAYMENT_REQUEST = "/api/Activity/PaymentRequests";
export const ACTIVITY_EXPENSE_FORM_DOWNLOAD =
  "/api/Activity/ExpenseFormDownload";
export const PAYMENT_REQUEST_SIGNIN_SHEET =
  "/api/Activity/PaymentRequestSignInSheet";
export const PAYMENT_REQUEST_DOWNLOAD_RELATED_ACTIVITIES =
  "/api/Activity/PaymentRequestDownload";
export const COMPLIANCE_ACKNOWLEDGE_FORM_FACULTY =
  "/api/Activity/ComplianceAcknowledgementFormFaculty";
export const MEDICAL_ACTIVITY_GRAND_SUPPLIER_ACCESS =
  "/api/Activity/GrantSupplierAccess";
export const MEDICAL_ACTIVITY_GRAND_SUPPLIER_ACCESSES =
  "/api/Activity/GrantSupplierAccesses";
export const MEDICAL_ACTIVITY_GRAND_SUPPLIER_ACCESS_GENERATE_PIN =
  "/api/Activity/GrantSupplierAccessGeneratePin";
export const PAYMENT_REQUEST_CONTRACT = "/api/Activity/PaymentRequestContract";
export const PAYMENT_REQUEST_FILE = "/api/Activity/PaymentRequestFile";
export const PAYMENT_REQUEST_GET_ADVISING_HONORARIUM_DETAILS =
  "/api/Activity/PaymentRequestAdvisingHonorarium";
export const PAYMENT_REQUEST_SAVE_ADVISING_HONORARIUM =
  "/api/Activity/PaymentRequestAdvisingHonorariums";
export const PAYMENT_REQUEST_GET_COMPLIANCE_FORM =
  "/api/Activity/PaymentRequestComplianceForm";
export const PAYMENT_REQUEST_SAVE_COMPLIANCE_FORM =
  "/api/Activity/PaymentRequestComplianceForms";
export const PAYMENT_REQUEST_GET_RELATED_ACTIVITIES =
  "/api/Activity/PaymentRequestRelatedActivity";
export const PAYMENT_REQUEST_SAVE_RELATED_ACTIVITIES =
  "/api/Activity/PaymentRequestRelatedActivities";
export const PAYMENT_REQUEST_LINKED_ACTIVITY_CONTROL =
  "/api/Activity/PaymentRequestLinkedActivityControl";
export const PAYMENT_REQUEST_LINKED_ACTIVITY_SEARCH =
  "/api/Activity/PaymentRequestLinkedActivitySearch";
export const PAYMENT_REQUEST_RELATED_ACTIVITIES_REFRESH =
  "/api/Activity/PaymentRequestRelatedActivityRefresh";

// Activity Search faculty PopUp
export const ACTIVITY_FACULTY_SEARCH_CONTROLS =
  "/api/Activity/FacultySearchControl";
export const FETCH_FACULTY_SEARCH = "/api/Activity/FacultySearch";
export const ADD_FACULTY = "/api/Activity/AddFaculty";
export const FIELD_ACTIVITY_FACULTY_CHANGE =
  "/api/Activity/FieldActivityFacultyChange";

// Teritorry search PopUp API
export const FETCH_TERRITORY_SEARCH_CONTROL =
  "/api/Activity/TerritorySearchControl";
export const ACTIVITY_TERRITORY_SEARCH =
  "/api/Activity/ActivityTerritorySearch";
export const INVITEE_CHECKBOX = "/api/Activity/InviteeCheckbox";
export const INVITEE_ADDRESS = "/api/Activity/InviteeAddress";

// Full Search PopUp
export const FETCH_FULL_SEARCH_CONTROL = "/api/Activity/FullSearchControl";
export const ACTIVITY_FULL_SEARCH = "/api/Activity/FullSearch";

// write IN PopUp
export const WRITE_IN_INVITEE_SAVE = "/api/Activity/WriteInInviteeSave";
export const WRITE_IN_INVITEE_DELETE = "/api/Activity/WriteInInviteeDelete";
export const WRITE_IN_INVITEE = "/api/Activity/WriteInInvitee";

// Activity -> Program Validation

export const ACTIVITY_PROGRAM_VALIDATION = "/api/Activity/ProgramValidation";
export const CHECK_MISSING_LILLY_CUSTOMER_ID =
  "/api/Activity/CheckMissingLillyCustomerId";
export const SAVE_PROGRAM_VALIDATIONS = "/api/Activity/ProgramValidations";
// Activity Program CloseOut -> Audence
export const AUDIENCE_VALIDATION = "/api/Activity/AudienceValidation";
export const SAVE_AUDIENCE_VALIDATIONS = "/api/Activity/AudienceValidations";
export const AUDIENCE_VALIDATION_ATTENDEE =
  "/api/Activity/AudienceValidationAttendee";
export const SAVE_AUDIENCE_VALIDATION_ATTENDEES =
  "/api/Activity/AudienceValidationAttendees";

// Activity -> Field Activity
export const GET_USER_TRAINING = "/api/Header/UserTraining";
export const GET_FIELD_ACTIVITY_INFORMATION =
  "/api/Activity/FieldActivityInformation";
export const SAVE_FIELD_ACTIVITY_INFORMATION =
  "/api/Activity/FieldActivityInformations";
export const FIELD_ACTIVITY_CANCEL_ACTIVITY_CONTROL =
  "/api/Activity/CancelActivityControl";
export const FIELD_ACTIVITY_SAVE_CANCEL_ACTIVITY =
  "/api/Activity/CancelActivity";
export const GET_FIELD_ACTIVITY_COST_CENTER_HISTORY =
  "/api/FieldActivity/CostCenterHistory";
export const GET_FIELD_ACTIVITY_PID_DISTRIBUTION_CONTROL =
  "/api/Activity/PIDDistributionControl";
export const GET_FIELD_ACTIVITY_ADDITIONAL_PID_DISTRIBUTION =
  "/api/FieldActivity/ActivityAdditionalPIDDistribution";
export const GET_FIELD_ACTIVITY_REPRESENTATIVE_CONTACT_INFO =
  "/api/Activity/RepresentativeAddress";
export const GET_ACTIVITY_SERIES = "/api/Activity/ActivitySeries";
export const CHECK_FACULTYIDENTIFICATION_RULE =
  "/api/Activity/CheckFacultyIdentificationRule";
export const CHECK_AUDIENCE_AND_FACULTY_CONSOLIDATION =
  "/api/Activity/CheckAudienceAndFacultyConsolidation";
export const CAN_NAVIGATE_TO_CLOSEOUT = "/api/Activity/CanNavigatetoCloseOut";
export const MATCH_ACTIVITY = "/api/Activity/MatchActivity";
export const CHECK_LILLY_CLOSEOUT_ENABLED =
  "/api/Activity/CheckLillyCloseOutEnabled";
export const ALERT_APPROVAL_STATUS = "/api/Activity/AlertApprovalStatus";
export const GET_ACTIVITY_LOCATION_CONTROL =
  "/api/Activity/ActivityLocationControl";
export const SEARCH_PID_DISTRIBUTION = "/api/Activity/PIDDistributionSearch";
export const DOWNLOAD_PID_DISTRIBUTION =
  "/api/Activity/PIDDistributionExcelDownload";
export const GET_TERRITORY_SEARCH = "/api/Activity/TerritorySearch";
export const ACTIVITY_REPRESENTATIVE_CONTROL = "/api/Activity/Representative";
export const ACTIVITY_QR_CODE = "/api/Activity/QRCode";
export const ACTIVITY_SAVE_DATETIME = "/api/Activity/ActivityDateTimes";
export const SAVE_FIELD_ACTIVITY_REPRESENTATIVE =
  "/api/Activity/Representatives";
export const SAVE_FIELD_ACTIVITY_LOCATIONS = "/api/Activity/ActivityLocations";
export const GET_FACULTY_INFORMATION = "api/Activity/FacultyInformation";
export const ACTIVITY_SAVE_TRAVELS = "/api/Activity/ActivityTravels";
export const SAVE_FIELD_PROGRAM_VALIDATIONS =
  "/api/Activity/FieldProgramValidations";
export const CONFIRM_FACULTY = "api/Activity/ConfirmFaculty";
export const DELETE_FACULTY = "api/Activity/DeleteFaculty";
export const RETAIN_ACTIVITY_INFORMATION =
  "api/Activity/RetainActivityInformation";
export const SAVE_FACULTY_INFORMATION = "api/Activity/FacultyInformations";
export const ACTIVITY_OVCHANGE = "api/Activity/OVChange";
export const ACTIVITY_INVITEE_LIST = "api/Activity/ActivityInviteeList";
// Upload Reciept
export const GET_ACTIVITY_UPLOAD_RECEIPT_CONTROL =
  "api/Activity/ActivityReceiptControl";
export const SAVE_UPLOAD_RECEIPT = "api/Activity/ActivityReceipts";
export const GET_RECEIPT_LIST = "api/Activity/ActivityReceipt";
export const DELETE_RECEIPT_LIST = "api/Activity/ActivityReceiptDelete";
export const ACTIVITY_RECEIPT_BREAKDOWN =
  "api/Activity/ActivityReceiptBreakdown";
export const SAVE_ACTIVITY_RECEIPT_BREAKDOWN =
  "api/Activity/ActivityReceiptBreakdowns";

// old Audience
export const GET_AUDIENCE_CONTROL = "/api/Activity/AudienceControl";

// New Audience
export const GET_NEW_AUDIENCE_CONTROL = "api/Activity/NewAudienceControl";
export const GET_WRITE_IN_INVITEE = "api/Activity/WriteInInvitee";
export const DELETE_RSVP_REGISTRANT = "api/Activity/RSVPRegistrantDelete";
export const SAVE_AND_REFRESH_INVITEE = "api/Activity/SaveAndRefreshInvitee";
export const DOWNLOAD_BRAND_TEMPLATE = "api/Activity/BrandTemplateDownload";
export const UPLOAD_INVITEE = "api/Activity/InviteeUpload";
export const INVITEE_FILE_DOWNLOAD = "api/Activity/InviteeFileDownload";
export const IS_INVITEE_DELETE = "api/Activity/IsInviteeDeleted";
export const GET_INVITEE_SIGNATURE = "api/Activity/InviteeSignature";
export const SAVE_INVITEE_SIGNATURE = "api/Activity/InviteeSignatures";
export const CHECK_INVITEE_SIS = "api/Activity/CheckInviteeSIS";
export const SIGN_IN_SHEET_CONTROL = "api/Activity/SignInSheetUploadControl";
export const SAVE_SIGN_IN_SHEET = "api/Activity/SignInSheetUpload";
export const SAVE_EMAIL_INVITEE = "api/Activity/InviteeEmail";
export const GENERATE_SIS = "api/Activity/ActivitySISGenerate";
export const DOWNLOAD_SIS_FILE = "api/Activity/ActivitySignInSheetFile";
export const DELETE_SIS_FILE = "api/Activity/ActivitySignInSheetDelete";
export const GET_ORDER_MATERIAL = "api/Activity/OrderMaterial";
export const SAVE_ORDER_MATERIAL = "api/Activity/OrderMaterials";
export const DELETE_ORDER_MATERIAL = "api/Activity/OrderMaterialDelete";
export const SAVE_AUDIENCE = "api/Activity/NewAudiences";
// program close out
export const PROGRAM_CLOSE_OUT = "api/Activity/ProgramCloseOut";
export const FETCH_ACTIVITY_SUMMARY_FILE = "api/Activity/ActivitySummaryFile";
// Meeting Materials
export const GET_MEETING_MATERIAL_CONTROL =
  "api/Activity/MeetingMaterialControl";
export const UPLOAD_MEETING_MATERIAL = "api/Activity/MeetingMaterialUpload";
export const SAVE_MEETING_MATERIAL = "api/Activity/MeetingMaterials";
export const DELETE_MEETING_MATERIAL = "api/Activity/MeetingMaterialDelete";
export const FETCH_MEETING_MATERIAL_FILE = "api/Activity/MeetingMaterialFile";
// Comments
export const FETCH_COMMENTS = "api/Activity/Comments";
// Representative
export const FETCH_PARTNER_REPRESENTATIVE =
  "/api/Activity/PartnerRepresentative";
// Save Activity info
export const SAVE_FIELD_ACTIVITY = "/api/Activity/SaveActivityInformations";
// program close - financial
export const FETCH_FINANCIAL_VALIDATION = "/api/Activity/FinancialValidation";
export const FETCH_FINANCIAL_VALIDATION_RECEIPT =
  "/api/Activity/FinancialValidationReceipt";
export const DOWNLOAD_FINANCIAL_VALIDATION_EXCEL =
  "/api/Activity/FinancialValidationExcel";
export const CHECK_MISSING_LILLY_CUSTOMERID =
  "/api/Activity/CheckMissingLillyCustomerId";
export const SAVE_FINANCIAL_VALIDATION = "/api/Activity/FinancialValidations";

// Activity -> Brand Activity
export const GET_BRAND_ACTIVITY_INFORMATION =
  "/api/Activity/BrandActivityInformation";
export const GET_BRAND_ACTIVITY_SPONSOR_CONTACT =
  "/api/Activity/ActivitySponsorContact";
export const TLMAP_SEARCH = "/api/Activity/TLMapSearch";
export const PID_DISTRIBUTION_EXCEL_DOWNLOAD =
  "/api/Activity/PIDDistributionExcelDownload";
export const SAVE_BRAND_ACTIVITY_INFORMATIONS =
  "/api/Activity/BrandActivityInformations";
export const ACTIVITY_TOPIC = "/api/Activity/ActivityTopic";
export const ADVISORY_DESCRIPTION_CONTRACT_PREVIEW =
  "/api/Activity/AdvisoryDescriptionContractPreview";
export const GET_ACTIVITY_FINANCE = "/api/Activity/ActivityFinance";
export const BUDGET_APPROVAL_STATUS = "/api/Activity/BudgetApprovalStatus";
export const CHECK_PAY_ONSITE = "/api/Activity/CheckPayOnSite";
export const SAVE_ACTIVITY_FINANCES = "/api/Activity/ActivityFinances";
export const FETCH_ARF_PARTICIPANT = "/api/Activity/ARFParticipant";
export const SAVE_ARF_PARTICIPANT = "/api/Activity/ARFParticipants";

// PNR linked Acttivity
export const ADD_LINKED_ACTIVITY_SEARCH =
  "/api/Activity/AddLinkedActivitySearch";
export const ADD_LINKED_ACTIVITY_CONTROL =
  "/api/Activity/AddLinkedActivityControl";

export const FETCH_PNR_RELATED_ACTIVITIES = "/api/Activity/PNRRelatedActivity";
export const SAVE_PNR_RELATED_ACTIVITIES = "/api/Activity/PNRRelatedActivities";
